<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="page-main" v-loading="listLoading">
      <div class="panel-heading">
        <el-button plain icon="el-icon-arrow-left" @click="backToVhost"></el-button>
        <span class="se-panel-title z-padding-left-5-precent ver-sub">免费虚拟主机管理</span>
      </div>
      <div class="server-header vhost ub-box">
        <div class="header-left ub-box ub-ver ub-ver-v">
          <div class="header-left-icon"></div>
        </div>
        <div class="header-right">
          <table class="server-header-table">
            <tr>
              <td class="z-textAlign-right">FTP账号：</td>
              <td>{{vhostInfo.ftp_user}}</td>
              <td>&nbsp;&nbsp;&nbsp;</td>
              <td class="z-textAlign-right">FTP地址：</td>
              <td v-if="vhostInfo.ip_type === '共享'">{{vhostInfo.ip}}（{{vhostInfo.ip_type}}）</td>
              <td v-if="vhostInfo.ip_type === '独享'">{{vhostInfo.ip_bind}}（{{vhostInfo.ip_type}}）</td>
              <el-button type="primary" size="mini" @click="FtpPwdSet" style="margin-top: -6px;">设置密码</el-button>
            </tr>
            <tr>
              <td class="z-textAlign-right">主机状态：</td>
              <td>
                <span v-if="vhostInfo.Pstate === '2'">{{pstate}}</span>
                <span v-if="vhostInfo.Pstate != '2'" class="z-color-66-orange">{{pstate}}</span>
              </td>
              <td>&nbsp;&nbsp;&nbsp;</td>
              <td class="z-textAlign-right">到期时间：</td>
              <td>{{vhostInfo.endtime}}</td>
              <el-button type="primary" size="mini" @click="activeName = 'five'" style="margin-top: -6px;">免费延期</el-button>
            </tr>
          </table>
        </div>

      </div>
      <el-tabs v-model="activeName" type="border-card">
        <el-tab-pane label="基本信息" name="first">
          <el-row>
            <el-col :span="24"><div class="row-title">
              基本信息
            </div>
            </el-col>
          </el-row>
          <el-row type="flex" align="middle" class="row-border">
            <el-col :sm="6" :md="4" :lg="3"><div class="grid-content z-padding-left-30-precent z-color-muted">网站域名 :</div></el-col>
            <el-col :sm="18" :md="20" :lg="{span:21,pull:1}"><div class="grid-content z-padding-left-20-precent">
              <p class="z-lineHeight-18 z-margin-top-5-precent"><a class="z-color-a a-underline-link" :href="'http://'+ vhostInfo.domainname0" target="_blank">http://{{vhostInfo.domainname0}}</a></p>
              <p class="z-lineHeight-18" v-if="option.id != 0 && index < 2" v-for="(option,index) in vhostInfo.domainname">
                <a class="z-color-a a-underline-link" :href="'http://'+ option.DomainName" target="_blank">http://{{option.DomainName}}</a>
                <span v-if="option.beian == 0" style="background-color: #ff6600;color: #fff;padding: 0 2px;">免备案</span>
              </p>
              <el-button type="primary" size="mini" @click="Operate('domain','域名绑定')">修改/添加</el-button>
            </div></el-col>
          </el-row>
          <el-row type="flex" align="middle" class="row-border">
            <el-col :sm="6" :md="4" :lg="3"><div class="grid-content z-padding-left-30-precent z-color-muted">网站配置 :</div></el-col>
            <el-col :sm="18" :md="20" :lg="{span:21,pull:1}">
              <div class="grid-content-small z-padding-left-20-precent">
                <el-row>
                  <el-col :sm="8" :span="4" class="z-color-666">网站空间：<span class="z-color-green z-font-weight-700">{{vhostInfo.websize}}</span></el-col>
                  <el-col :sm="8" :span="4" class="z-color-666">IP地址：
                    <span v-if="vhostInfo.ip_type === '共享'" class="z-color-green z-font-weight-700">{{vhostInfo.ip}}（{{vhostInfo.ip_type}}）</span>
                    <span v-if="vhostInfo.ip_type === '独享'" class="z-color-green z-font-weight-700">{{vhostInfo.ip_bind}}（{{vhostInfo.ip_type}}）</span>
                  </el-col>
                  <el-col :sm="8" :span="4" class="z-color-666">MySql数据库：<span class="z-color-green z-font-weight-700">{{vhostInfo.mysql}}</span></el-col>
                </el-row>
                <el-row>
                  <el-col :sm="8" :span="4" class="z-color-666">语言环境：<span class="z-color-green z-font-weight-700">{{vhostInfo.system}}</span></el-col>
                  <el-col :sm="8" :span="4" class="z-color-666">月流量：<span class="z-color-green z-font-weight-700">{{vhostInfo.liuliang}}</span></el-col>
                  <el-col :sm="8" :span="4" class="z-color-666">MsSql数据库：<span class="z-color-green z-font-weight-700">{{vhostInfo.mssql}}</span></el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
          <el-row type="flex" align="middle" class="row-border">
            <el-col :sm="6" :md="4" :lg="3"><div class="grid-content z-padding-left-30-precent z-color-muted">流量状态 :</div></el-col>
            <el-col :sm="18" :md="20" :lg="{span:21,pull:1}">
              <div class="grid-content z-padding-left-20-precent">
                <span v-if="vhostInfo.liuliang === '不限'">本月已用流量：{{vhostInfo.liuliang_month}}</span>
                <div v-if="vhostInfo.liuliang != '不限'" class="host-uselevel-bar progress">
                  <div class="progress-bar progress-bar-blue" :style="'width: '+ vhostInfo.ll_bfb +'%'">
                  </div>
                  <span class="usage-text" :title="vhostInfo.liuliang_month +'/'+ vhostInfo.liuliang">
										<span class="z-color-66-orange">{{vhostInfo.liuliang_month}}</span>/<span class="z-color-666">{{vhostInfo.liuliang}}</span>
										</span>
                </div>
                &nbsp;
                <el-button type="info" plain size="mini" @click="LogLiuliang('lastmonth')">流量详情</el-button>
                <el-button type="info" plain size="mini" @click="activeName = 'fourth'">日志分析</el-button>
              </div>
            </el-col>
          </el-row>
          <el-row type="flex" align="middle" class="row-border">
            <el-col :sm="6" :md="4" :lg="3"><div class="grid-content z-padding-left-30-precent z-color-muted">空间状态 :</div></el-col>
            <el-col :sm="18" :md="20" :lg="{span:21,pull:1}">
              <div class="grid-content z-padding-left-20-precent">
                <div class="host-uselevel-bar progress">
                  <div class="progress-bar progress-bar-blue" :style="'width: '+ vhostInfo.websize_bfb +'%'">
                  </div>
                  <span class="usage-text" :title="vhostInfo.mysql_used_txt +'/'+ vhostInfo.mysql">
										<span class="z-color-66-orange">{{vhostInfo.websize_used}}</span>/<span class="z-color-666">{{vhostInfo.websize}}</span>
										</span>
                </div>
              </div>
            </el-col>
          </el-row>
          <br>
          <el-row>
            <el-col :span="24"><div class="row-title">
              常规管理
            </div>
            </el-col>
          </el-row>
          <div class="clearfix z-padding-left-10-precent">
            <div class="operate-item host-opicon-domain open" @click="Operate('domain','域名绑定')" style="display: block;">
              <span>域名绑定</span>
            </div>
            <div class="operate-item host-opicon-restart open" @click="Restart(false)" style="display: block;">
              <span>重启主机</span>
            </div>
            <div class="operate-item host-opicon-mainpage open" @click="Operate('mainpage','默认首页文档设置')" style="display: block;">
              <span>默认首页设置</span>
            </div>
            <div class="operate-item host-opicon-404 open" @click="Operate('set404','404错误文档')" style="display: block;">
              <span>404错误页面</span>
            </div>
            <div class="operate-item host-opicon-errorscript open" @click="Operate('errorscript','脚本错误信息设置')" style="display: block;">
              <span>脚本错误设置</span>
            </div>
            <div class="operate-item host-opicon-redirectJump open" @click="Operate('redirectJump','301重定向')" style="display: block;">
              <span>301重定向</span>
            </div>
            <div class="operate-item host-opicon-php open" @click="Operate('php','php版本设置')" style="display: block;">
              <span>PHP版本设置</span>
            </div>
            <div class="operate-item host-opicon-net open" @click="Operate('net','.net版本设置')" style="display: block;">
              <span>.NET版本设置</span>
            </div>
          </div>
          <br>
          <el-row>
            <el-col :span="24"><div class="row-title">
              高级管理
            </div>
            </el-col>
          </el-row>
          <div class="z-padding-left-10-precent">
            <div class="operate-item host-opicon-chain open" @click="Operate('chain','防盗链设置')" style="display: block;">
              <span>防盗链设置</span>
            </div>
            <div class="operate-item host-opicon-compress open" @click="Operate('compress','文件压缩&解压缩')" style="display: block;">
              <span>压缩解压</span>
            </div>
            <div class="operate-item host-opicon-clearWeb open" @click="ConfiemClear(false)" style="display: block;">
              <span>清空主机</span>
            </div>
            <div class="operate-item host-opicon-permission open" @click="Operate('permission','目录脚本执行权限管理')" style="display: block;">
              <span>执行权限</span>
            </div>
            <div class="operate-item host-opicon-lock open" @click="Operate('lock','目录读写权限管理')" style="display: block;">
              <span>目录权限</span>
            </div>
            <div class="operate-item host-opicon-domain open" @click="Operate('blacklist','IP黑名单')" style="display: block;">
              <span>IP黑白名单</span>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="MySql数据库" name="second">
          <div v-if="vhostInfo.mysql_used != 0">
            <el-row>
              <el-col :span="24"><div class="row-title">
                基本信息
              </div>
              </el-col>
            </el-row>
            <el-row type="flex" align="middle" class="row-border">
              <el-col :sm="6" :md="4" :lg="3"><div class="grid-content z-padding-left-30-precent z-color-muted">数据库名称 :</div></el-col>
              <el-col :sm="6" :md="8" :lg="{span:5,pull:1}"><div class="grid-content z-padding-left-20-precent">{{vhostInfo.mysql_userid}}</div></el-col>
              <el-col :sm="6" :md="4" :lg="3"><div class="grid-content z-padding-left-30-precent z-color-muted">数据库地址 :</div></el-col>
              <el-col :sm="6" :md="8" :lg="{span:5,pull:1}"><div class="grid-content z-padding-left-20-precent">127.0.0.1</div></el-col>
            </el-row>
            <el-row type="flex" align="middle" class="row-border">
              <el-col :sm="6" :md="4" :lg="3"><div class="grid-content z-padding-left-30-precent z-color-muted">数据库账号 :</div></el-col>
              <el-col :sm="6" :md="8" :lg="{span:5,pull:1}"><div class="grid-content z-padding-left-20-precent">{{vhostInfo.mysql_userid}}</div></el-col>
              <el-col :sm="6" :md="4" :lg="3"><div class="grid-content z-padding-left-30-precent z-color-muted">空间状态 :</div></el-col>
              <el-col :sm="6" :md="8" :lg="{span:5,pull:1}">
                <div class="grid-content z-padding-left-20-precent">
                  <div class="host-uselevel-bar progress">
                    <div class="progress-bar progress-bar-blue" :style="'width: '+ vhostInfo.mysql_bfb +'%'">
                    </div>
                    <span class="usage-text" :title="vhostInfo.mysql_used_txt +'/'+ vhostInfo.mysql">
										<span class="z-color-66-orange">{{vhostInfo.mysql_used_txt}}</span>/<span class="z-color-666">{{vhostInfo.mysql}}</span>
										</span>
                  </div>
                </div>
              </el-col>
            </el-row>
            <br>
            <el-row>
              <el-col :span="24"><div class="row-title">
                数据库操作
              </div>
              </el-col>
            </el-row>
            <div class="clearfix z-padding-left-10-precent">
              <div class="operate-item sql-password open" @click="SqlSetpwd('mysql')" style="display: block;">
                <span>修改数据库密码</span>
              </div>
              <a :href="'http://'+ vhostInfo.ip +'/phpmyadmin/index.php'" target="_blank">
                <div class="operate-item host-opicon-php open" style="display: block;">
                  <span>PhpMyadmin</span>
                </div>
              </a>
              <div class="operate-item sql-clear open" @click="SqlClear('mysql')" style="display: block;">
                <span>清空数据库</span>
              </div>
              <div class="operate-item sql-links open" @click="Extlinks('mysql')" style="display: block;">
                <span>外部连接管理</span>
              </div>
            </div>
            <br>
            <el-row>
              <el-col :span="24"><div class="row-title">
                数据库备份
              </div>
              </el-col>
            </el-row>
            <el-row type="flex" align="middle" class="row-border">
              <!--<el-col :sm="6" :md="4" :lg="3"><div class="grid-content z-padding-left-30-precent z-color-muted">数据库备份 :</div></el-col>-->
              <el-col :sm="18" :md="20" :lg="{span:21}"><div class="grid-content z-padding-left-20-precent">
                <el-table
                  :data="mysqlTable"
                  border
                  :show-header = false
                  style="width: 100%;margin: 5px 5px 5px 0;">
                  <el-table-column
                    prop="date"
                    width="100">
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    min-width="50">
                  </el-table-column>
                  <el-table-column
                    prop="button"
                    width="180">
                    <template slot-scope="scope">
                      <el-button type="primary" size="mini" @click="SqlBak('mysql',scope.row.index)">建立备份</el-button>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="address">
                    <template slot-scope="scope">
                      <el-button v-if="scope.row.beifen" type="info" size="mini" @click="SqlReback('mysql',scope.row.index)">从备份中还原</el-button>
                      <el-button v-if="!scope.row.beifen" type="info" size="mini" disabled>从备份中还原</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div></el-col>
            </el-row>
            <div class="alert-warn z-margin-top-15-precent">
              1、您的备份文件存放在您的FTP根目录的 “data” 文件夹。<br>
              2、如果您要将自己的数据库导入服务器，按照以下步骤：<br>
              <span class="z-color-green z-margin-left-15-precent">建立备份。</span><br>
              <span class="z-color-green z-margin-left-15-precent">将您本地的数据库备份文件上传到data文件夹，覆盖服务器上的备份文件。</span><br>
              <span class="z-color-green z-margin-left-15-precent">从备份中还原数据库。</span><br>
              3、如果导入过程中发生意外，需要重新导入，您要先初始化数据库。<br>
              4、在备份还原前，请您先停止您的网站一分钟后再操作，否则数据库正在使用可能会造成操作失败。<br>
            </div>
          </div>
          <div v-if="vhostInfo.mysql_used === 0" class="ub-box ub-ver-h z-textAlign-center">
            <div class="z-margin-bottom-50-precent">
              <img src="../../assets/imgs/vhost-sql.png" alt="">
              <br>
              <span class="z-font-size-14">您的mysql数据库尚未初始化</span>
              <br>
              <br>
              <el-button type="primary" size="mini" @click="InitMysql" class="z-margin-right-10-precent">点击一键初始化</el-button>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="预装网站" name="third">
          <el-row>
            <el-col :span="24"><div class="row-title">
              软件预装
            </div>
            </el-col>
          </el-row>
          <table>
            <tr>
              <td class="z-color-muted" style="width: 80px;padding-left: 2.8rem;">可选软件列表 :</td>
              <td class="z-padding-left-25-precent clearfix">
                <label :for="'softid_'+ index" v-for="(item,index) in websoftList"  style="display: inline;cursor: pointer;">
                  <table class="table-yuzhuang">
                    <tbody>
                    <tr>
                      <td><input type="radio" v-model="softname" :value="item[2]" :id="'softid_'+ index" name="softid"></td>
                      <td>
                        <img :src="'https://img.abeiyun.com/img/yzsoft/soft'+ index +'.gif'" alt="">
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2">
                        <a :href="item[1]" target="_blank">{{item[0]}}</a>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </label>
              </td>
            </tr>
          </table>
          <el-row type="flex" align="middle" class="row-border">
            <el-col :sm="6" :md="4" :lg="3"><div class="grid-content z-padding-left-30-precent z-color-muted" style="border-top: 1px solid #eee;">安装路径 :</div></el-col>
            <el-col :sm="18" :md="20" :lg="{span:21,pull:1}"><div class="grid-content z-padding-left-20-precent clearfix" style="border-top: 1px solid #eee;">
              \web\
              <el-input v-model="softpath" style="width: 300px"></el-input>
              <el-button v-show="softname != ''" type="primary" style="vertical-align: 1px;" @click="WebInstall">开始上传软件</el-button>
              <el-button v-show="softname === ''" type="primary" style="vertical-align: 1px;" disabled>开始上传软件</el-button>
            </div></el-col>
          </el-row>
          <el-row type="flex" align="middle" class="row-border">
            <el-col :sm="6" :md="6" :lg="3"><div class="grid-content z-padding-left-30-precent z-color-muted">安装说明 :</div></el-col>
            <el-col :sm="18" :md="18" :lg="{span:21,pull:1}"><div class="grid-content-small z-padding-left-25-precent">
              <p>1.选择你要安装的软件，然后填写安装目录，点击 “开始上传软件” 即可将软件安装到你选择的目录中。</p>
              <p>2.建议先通过FTP清空要安装到的目录，然后再进行安装。同一个目录重复安装，会覆盖原来的安装。</p>
              <p class="z-color-red">3.上述软件均是UTF-8版国际通用编码。我司只提供安装服务，不提供相关的技术支持，如需帮助，请咨询相关软件的服务商。</p>
            </div></el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="日志分析" name="fourth">
          <div v-loading="logFileLoading">
            <el-row>
              <el-col :span="24"><div class="row-title row-title-border">
                概要统计（日期：{{logdate}}；独立IP数：{{lognum}}）
              </div>
              </el-col>
            </el-row>
            <table class="table-log">
              <tr style="background: #eee;">
                <td class="z-font-weight-700" style="width:100px">文件类型：</td>
                <td class="z-font-weight-700" v-for="col in logFile">{{col.file_type}}</td>
              </tr>
              <tr>
                <td class="text-left" style="width:100px">访问次数：</td>
                <td v-for="col in logFile">
                  <a href="javascript:;" class="z-textAlign-center z-color-a a-underline-link" @click="HitsList('.'+col.file_type,'文件类型')">{{col.file_num}}</a>
                </td>
              </tr>
              <tr>
                <td class="text-left" style="width:100px">消耗带宽：</td>
                <td v-for="col in logFile">
                  <a href="javascript:;" class="z-textAlign-center z-color-a a-underline-link" @click="BytesList('.'+col.file_type,'文件类型')">{{col.file_bytes}}</a>
                </td>
              </tr>
            </table>
          </div>
          <div v-loading="logStateLoading">
            <el-row>
              <el-col :span="24"><div class="row-title row-title-border">
                概要统计
              </div>
              </el-col>
            </el-row>
            <table class="table-log">
              <tr style="background: #eee;">
                <td class="z-font-weight-700" style="width:100px">状态码：</td>
                <td class="z-font-weight-700" v-for="col in logState">{{col.sc_status}}</td>
              </tr>
              <tr>
                <td class="text-left" style="width:100px">访问次数：</td>
                <td v-for="col in logState">
                  <a href="javascript:;" class="z-textAlign-center z-color-a a-underline-link" @click="HitsList(col.sc_status,'状态码')">{{col.status_num}}</a>
                </td>
              </tr>
              <tr>
                <td class="text-left" style="width:100px">消耗带宽：</td>
                <td v-for="col in logState">
                  <a href="javascript:;" class="z-textAlign-center z-color-a a-underline-link" @click="BytesList(col.sc_status,'状态码')">{{col.status_bytes}}</a>
                </td>
              </tr>
            </table>
          </div>
          <el-button v-show="logListType === 'domain'" type="primary">来路域名排行</el-button>
          <el-button v-show="logListType != 'domain'" @click="SourceDomain" style="margin-left: 0;">来路域名排行</el-button>
          <el-button v-show="logListType === 'ip'" type="primary">IP消耗带宽排行</el-button>
          <el-button v-show="logListType != 'ip'" @click="IPBandwidth">IP消耗带宽排行</el-button>
          <div v-loading="logListLoading">
            <table class="table-log z-margin-top-15-precent" ref="el" style="visibility: hidden">
              <thead>
              <tr>
                <th>
                  <span v-show="logListType === 'url'" class="z-font-weight-700">URL（{{logUrlType}}：{{logStatus.replace('.','')}}）</span>
                  <span v-show="logListType === 'domain'" class="z-font-weight-700">来路域名排行（前100个）</span>
                  <span v-show="logListType === 'ip'" class="z-font-weight-700">IP消耗带宽排名（前100个）</span>
                </th>
                <th style="width:100px">
                  访问次数
                </th>
                <th style="width:100px">
                  带宽消耗
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in logList">
                <td>
                  <a :href="item.url" class="a-underline-link" style="color:red" target="_blank">{{item.url}}</a>
                </td>
                <td >{{item.all_hits}}</td>
                <td>
                  <span>{{item.all_bytes}}</span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </el-tab-pane>
        <el-tab-pane label="免费延期" name="five" v-loading="delayLoading">
          <div class="alert-info">
            1、为了节约系统资源，保留活跃用户，进一步发展免费虚拟主机，我们采用了定期申请延期的方案，免费产品到期后会自动删除，请及时延期或备份。<br>
            2、延期方式：发布使用感受在我们推荐的网站或其他同类的网站中 <a href="/help/content_1155.html" class="z-color-a z-curPonit a-underline-link" target="_blank">>>查看延期内容要求</a>
            <br>
            3、推荐发帖网站：<a v-for="item in post_addr" :href="item.href" class="z-color-a z-curPonit a-underline-link z-margin-right-5-precent" target="_blank">{{item.title}}</a>
            <br>
            4、发表后一小时内把发布截图在下方提交，工作时间三小时审核完成，如删除将会审核失败。
          </div>
          <div class="alert-deng" style="width: 228px;">
            每次延期成功可以增加 <span class="red-chunk">30</span> 天使用时间。
          </div>
          <el-form ref="cardForm" label-width="120px" class="clearfix">
            <el-form-item v-if="delayState == '审核通过'" label="发帖地址：">
              <el-input v-model="cardForm.url" placeholder="请输入发帖网址http://" style="width: 500px"></el-input>
            </el-form-item>
          </el-form>
          <el-form :inline="true" label-width="120px" class="clearfix">
            <!--<el-form-item label="微信账号：" style="margin-right: 4rem">
              <span v-if="weixin">微信帐号已经绑定（{{nickname}}）</span>
              <br v-if="weixin">
              <img v-if="weixin" :src="headimgurl" alt="微信头像" >
              <span v-if="!weixin">微信帐号尚未绑定，<router-link to="/weixin" class="z-color-a">点击这里绑定>></router-link></span>
            </el-form-item>-->
            <el-form-item v-if="delayState == '审核通过'" label="发帖截图：">
              <div class="ub-box">
                <div class="ub-box">
                  <div class="col-img">
                    <label for="fileImg1" class="z-curPonit">
                      <img v-show="!showimg" src="../../assets/imgs/img3.png" alt="请上传现场图片" width="135" height="102">
                    </label>
                    <label for="fileImg1" class="z-curPonit">
                      <img v-show="showimg" :src="dataUrl" width="135" height="102"/>
                    </label>
                  </div>
                </div>
                <div class="z-margin-left-15-precent">
                  <p class="gff8 z-font-size-14">JPG或PNG格式</p>
                  <p class="z-font-size-12 z-color-999 z-padding-bottom-5-precent">请上传发帖截图</p>
                  <label for="fileImg1" class="choose-file">选择文件</label>
                  <input type="file" id="fileImg1" name="CertImg" @change="handleFileChange" ref="inputer" class="z-width-30-precent" style="visibility: hidden;">
                </div>
              </div>
              <el-button type="primary" @click="submitrForm" class="z-margin-top-20-precent">提交</el-button>
            </el-form-item>
            <el-form-item v-if="delayState == 0" label="">
              <div class="delaybox">
                <p class="z-font-size-22 z-color-red z-lineHeight-90">您还未到需要提交延期的时间</p>
                <p class="z-font-size-13 z-color-000">请在{{nexttime}}后提交</p>
              </div>
            </el-form-item>
            <el-form-item v-if="delayState == '待审核'" label="">
              <div class="delaybox">
                <p class="z-font-size-22 z-color-red z-lineHeight-90">延期申请等待审核中</p>
                <p class="z-font-size-13 z-color-000">我们将在工作时间3小时内审核完成</p>
                <p class="z-font-size-13 z-color-000">您可以稍作休息或做其他工作稍后来查看</p>
              </div>
            </el-form-item>
            <el-form-item v-if="delayState != '审核通过' && delayState != 0 && delayState != '待审核'" label="">
              <div class="delaybox">
                <p class="z-font-size-22 z-color-red z-lineHeight-90">延期审核失败</p>
                <p class="z-font-size-13 z-color-000">原因：{{delayState}}</p>
                <p>
                  <a href="/help/content_1155.html" class="z-color-a z-curPonit a-underline-link z-font-size-13" target="_blank">
                    >>查看失败原因和延期内容要求
                  </a>
                </p>
                <el-button type="primary" class="z-margin-top-5-precent" @click="delayState = '审核通过'">重新提交</el-button>
              </div>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="延期记录" name="six">
          <el-table :data="cardList" highlight-current-row show-header v-loading="listLoading" style="width: 100%;">
            <el-table-column prop="id" label="序号" align="left">
              <template slot-scope="scope">
                <span class="z-padding-left-5-precent">{{scope.row.id}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="Img" label="发帖截图" min-width="200" align="left">
              <template slot-scope="scope">
                <a href="javascript:;" @click="LargeImg(scope.row.Img)">
                  <img :src="scope.row.Img" alt="发帖截图" width="135" style="max-height: 135px">
                </a>
              </template>
            </el-table-column>
            <el-table-column prop="Url" label="网址" min-width="200" align="left">
              <template slot-scope="scope">
                <a :href="scope.row.Url" class="z-color-a z-curPonit a-underline-link" target="_blank">{{scope.row.Url}}</a>
              </template>
            </el-table-column>
            <el-table-column prop="SetTime" label="提交时间" align="left">
            </el-table-column>
            <el-table-column prop="CheckTime" label="审核时间" align="left">
            </el-table-column>
            <el-table-column prop="State" label="状态" align="left">
            </el-table-column>
          </el-table>
          <el-pagination background layout="total, sizes" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange" :page-size="20" :total="total" class="pull-left">
          </el-pagination>
          <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="count" :total="total">
          </el-pagination>
        </el-tab-pane>
      </el-tabs>
      <xdialog-loading :dialogLoading="dialogLoading"></xdialog-loading>
      <xdialog-warning :dialogWarning="dialogWarning" :warningMsg="warningMsg"></xdialog-warning>
      <el-dialog title="云虚拟主机续费" :lock-scroll="false" :visible.sync="dialogXufei" @close="xufeiForm.region = '1'" width="660px">
        <el-form label-width="180px" class="xufei-form">
          <el-form-item label="产品名称：" size="mini">
            <span class="z-font-size-12 z-color-666">{{xufeiForm.name}}</span>
          </el-form-item>
          <el-form-item label="ftp账号：">
            <span class="z-font-size-12 z-color-666">{{xufeiForm.ftp}}</span>
          </el-form-item>
          <el-form-item label="到期时间：">
            <span class="z-font-size-12 z-color-666">{{xufeiForm.endtime}}</span>
          </el-form-item>
          <el-form-item label="续费时长：">
            <el-select v-model="xufeiForm.region">
              <el-option label="1年" value="1"></el-option>
              <el-option label="2年" value="2"></el-option>
              <el-option label="3年" value="3"></el-option>
              <el-option label="4年" value="4"></el-option>
              <el-option label="5年" value="5"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="优惠券：">
            <el-select v-model="xufeiForm.coupon" placeholder="--请选择--" style="width: 300px">
              <el-option
                v-for="item in xufeiForm.yhq"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="续费后到期时间：">
            <span class="z-font-size-12 z-color-666">{{xufeiForm.newtime}}</span>
          </el-form-item>
          <el-form-item label="账户余额：">
            <span class="z-font-size-12 z-color-66-orange z-font-weight-700">{{xufeiForm.money}}元</span>
          </el-form-item>
          <el-form-item label="所需费用：">
            <span v-show="xufeiForm.loading" class="z-font-size-16 z-color-66-orange z-font-weight-700">价格计算中...</span>
            <span v-show="!xufeiForm.loading" class="z-font-size-16 z-color-66-orange z-font-weight-700">{{xufeiForm.price}}.</span>
            <span v-show="!xufeiForm.loading" class="z-font-size-12 z-color-66-orange">00元</span>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogXufei = false">取 消</el-button>
          <el-button type="primary" @click="Renew">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog title="云虚拟主机升级" :lock-scroll="false" :visible.sync="dialogXLevel" width="660px">
        <el-form label-width="140px" class="xufei-form">
          <el-form-item label="当前配置：">
            <span class="z-font-size-12 z-color-666">网站空间（{{shengjiForm.websize}}）MySql（{{shengjiForm.mysql}}）MsSql（{{shengjiForm.mssql}}）子网站（{{shengjiForm.subweb}}）带宽（{{shengjiForm.daikuan}}）</span>
          </el-form-item>
          <el-form-item label="升级的套餐名称：">
            <el-radio-group v-model="shengjiForm.type" size="small" @change="changeConfig">
              <el-radio-button v-for="(item, index) in shengjiForm.config"
                               :key="index"
                               :label="item.value">{{item.label}}</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="升级后配置：">
            <span v-for="option in shengjiForm.pset" class="z-font-size-12 z-color-666">{{option}}</span>
          </el-form-item>
          <el-form-item label="优惠券：">
            <el-select v-model="shengjiForm.coupon" placeholder="--请选择--" style="width: 300px">
              <el-option
                v-for="item in shengjiForm.yhq"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="到期时间：">
            <span class="z-font-size-12 z-color-666">{{shengjiForm.endtime}}</span>
          </el-form-item>
          <el-form-item label="账户余额：">
            <span class="z-font-size-12 z-color-66-orange z-font-weight-700">{{shengjiForm.money}}元</span>
          </el-form-item>
          <el-form-item label="所需费用：">
            <span v-show="shengjiForm.loading" class="z-font-size-16 z-color-66-orange z-font-weight-700">价格计算中...</span>
            <span v-show="!shengjiForm.loading" class="z-font-size-16 z-color-66-orange z-font-weight-700">{{shengjiForm.price}}.</span>
            <span v-show="!shengjiForm.loading" class="z-font-size-12 z-color-66-orange">00元</span>
          </el-form-item>
        </el-form>
        <div class="alert-warn alert-white-bg">
          <div class="alert-warn-title">
            说明
          </div>
          <div>
            1. 云虚拟主机升级后，到期时间不变，升级的差价计算精确到天；
          </div>
          <div>
            2. 升级/降级费用最低10元起，不足10元的按10元；
          </div>
          <div>
            3. 升级价格计算公式：(升级配置价格[年] - 原始配置价格[年]) / 365 * 到期剩余天数；
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogXLevel = false">取 消</el-button>
          <el-button type="primary" @click="Level">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog
        title="提示信息"
        :visible.sync="dialogAddSubsite"
        top="20%"
        width="520px"
        :lock-scroll=false
        custom-class="dialog-nopadding">
        <el-form label-width="130px">
          <el-form-item label="子目录文件夹：">
            <el-input v-model="subwebdir"></el-input>
          </el-form-item>
          <el-form-item label="子目录绑定域名：">
            <el-input v-model="selfdomain"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
        <el-button @click="dialogAddSubsite = false">取 消</el-button>
        <el-button type="primary" @click="SubwebAdd">确认添加</el-button>
        </span>
      </el-dialog>

      <el-dialog
        :visible.sync="dialogOperate"
        top="12%"
        width="660px"
        :lock-scroll=false
        :close-on-click-modal=false
        :close-on-press-escape=false
        custom-class="dialog dialog-scroll">
        <span slot="title" class="el-dialog__title">{{operateName}}</span>
        <div v-if="operateType === 'domain'" class="contentBox" style="height: 300px;">
          <div class="z-display-inlineBlock">
            <el-select v-model="domain.domainType" style="width:100px">
              <el-option
                v-for="item in domain.domainTypeSelect"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="z-display-inlineBlock">
            <el-input v-model="domain.name" style="width: 400px"></el-input>
          </div>
          <el-button type="primary" style="vertical-align: 1px;" @click="DomainAdd">增加绑定</el-button>
          <el-table :data="domain.table" :show-header=false class="table-empty" style="width: 100%;margin-top: 20px;margin-bottom: 20px;">
            <el-table-column prop="domainname" label="" width="497">
              <template slot-scope="scope">
                <a class="z-color-a a-underline-link" :href="scope.row.domainname" target="_blank">{{scope.row.domainname}}</a>
                <span v-if="scope.row.beian == 0" style="background-color: #ff6600;color: #fff;padding: 0 2px;">免备案</span>
              </template>
            </el-table-column>
            <el-table-column prop="caozuo" label="" width="180">
              <template slot-scope="scope">
                <el-button v-if="scope.row.beian != 0" type="danger" @click="DomainDel(scope.row.id)">删除绑定</el-button>
                <el-button v-if="scope.row.beian == 0" type="info" style="padding: 9px 9px;">免备案域名</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="alert-warn alert-white-bg">
            <div class="alert-warn-title">
              说明
            </div>
            <div>
              1、您最多可绑定<span class="z-color-66-orange">20</span>个域名。
            </div>
            <div>
              2、免费虚拟主机只能绑定在阿贝云注册的域名。
            </div>
            <div>
              3、域名绑定后会在2分钟左右自动解析生效。
            </div>
          </div>

        </div>
        <div v-if="operateType === 'mainpage'" class="contentBox" style="height: 300px;">
          <el-form label-width="150px" label-position="right">
            <el-form-item label="首页文件名：">
              <el-input v-model="mainpage.addIndexInput" style="width: 300px"></el-input>
              <el-button type="primary" style="vertical-align: 1px;" @click="IndexAdd">添加</el-button>
            </el-form-item>
            <el-form-item label="优先级设置：">
              选择文档进行排列，系统将根据排列顺序设置优先级。
              <ul class="index-list">
                <li v-for="(item, index) in mainpage.indexList" class="index-item clearfix">
                  <span class="index-item-rank">{{index + 1}}.</span>
                  <span class="index-item-name">{{item}}</span>
                  <div class="pull-right operate-box">
                    <a href="javascript:;" class="index-up" @click="IndexUp(index)" title="向上一位"></a>
                    <a href="javascript:;" class="index-down" @click="IndexDown(index)" title="向下一位"></a>
                    <a href="javascript:;" class="index-del" @click="IndexDel(index)" title="移除"></a>
                  </div>
                </li>
              </ul>
            </el-form-item>
          </el-form>
          <div class="alert-warn alert-white-bg">
            <div class="alert-warn-title">
              说明
            </div>
            <div>
              1、默认首页，即访问您的网站时的默认首页
            </div>
            <div>
              2、为了提高访问速度，建议您将有效的首页设为高优先级
            </div>
          </div>
        </div>
        <div v-if="operateType === 'set404'" class="contentBox" style="height: 200px;">
          自定义404出错页：
          <el-radio-group v-model="set404.radio">
            <el-radio :label="1">系统默认</el-radio>
            <el-radio :label="2">404.asp</el-radio>
            <el-radio :label="3">404.php</el-radio>
            <el-radio :label="4">404.htm</el-radio>
          </el-radio-group>
          <br>
          <br>
          <div class="alert-warn alert-white-bg">
            <div class="alert-warn-title">
              说明
            </div>
            <div>
              1、请先将您自定义的404错误提示网页文件传至web根目录下
            </div>
            <div>
              2、如您的页面是err404.htm且传到web/下，您只需在上面编辑框中输入err404.htm按设置即可
            </div>
            <div>
              3、错误提示网页只能为.htm、.html等纯网页文件，留空则使用系统默认页面
            </div>
            <div>
              4、脚本错误信息设置须为开启404错误页方才生效
            </div>
          </div>
        </div>
        <div v-if="operateType === 'errorscript'" class="contentBox" style="height: 200px;">
          将错误发送到浏览器：
          <el-radio-group v-model="errorscript.radio">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">关闭</el-radio>
          </el-radio-group>
          <br>
          <br>
          <div class="alert-warn alert-white-bg">
            <div class="alert-warn-title">
              说明
            </div>
            <div>
              1、建议只在调试程序时打开，将错误发送到浏览器可能会泄露程序敏感信息
            </div>
            <div>
              2、开启将错误发送到浏览器后，404页面以及其它自定义提示页面自动失效
            </div>
          </div>
        </div>
        <div v-if="operateType === 'redirectJump'" class="contentBox" style="height: 200px;">
          是否开启重定向：
          <el-radio-group v-model="redirectJump.radio">
            <el-radio :label="'open'">开启重定向</el-radio>
            <el-radio :label="'close'">关闭重定向</el-radio>
          </el-radio-group>
          <br>
          <br>
          <span v-show="redirectJump.radio === 'open'" style="padding-left: 25px;">重定向URL：</span>
          <el-input v-show="redirectJump.radio === 'open'" v-model="redirectJump.RedirectURL" style="width: 300px"></el-input>
          <div class="alert-warn alert-white-bg">
            <div class="alert-warn-title">
              说明
            </div>
            <div>
              1、如果您的网站已经转移，或者网站临时维护，您可以利用此功能，将本站的全部访问转发到您指定的其他地址
            </div>
          </div>
        </div>
        <div v-if="operateType === 'php'" class="contentBox" style="height: 200px;">
          选择切换版本类型：
          <el-radio-group v-model="php.radio">
            <br>
            <el-radio :label="'5.2.9'">PHP5.2.9</el-radio>
            <el-radio :label="'5.3.29'" style="margin-left: 37px;">PHP5.3.29</el-radio>
            <el-radio :label="'5.6.4'">PHP5.6.4</el-radio>
            <br>
            <br>
            <el-radio :label="'7.0.30'">PHP7.0.30</el-radio>
            <el-radio :label="'7.1.17'">PHP7.1.17</el-radio>
            <el-radio :label="'7.2.5'">PHP7.2.5</el-radio>
          </el-radio-group>
          <br>
          <br>
          <div class="alert-warn alert-white-bg">
            <div class="alert-warn-title">
              说明
            </div>
            <div>
              1、如果您的网站基于PHP，请选择适用您程序的PHP版本
            </div>
          </div>
        </div>
        <div v-if="operateType === 'net'" class="contentBox" style="height: 200px;">
          选择切换版本类型：
          <el-radio-group v-model="net.radio">
            <el-radio :label="'2.0'">.NET2.0/3.5</el-radio>
            <el-radio :label="'4.0'">.NET4.0</el-radio>
          </el-radio-group>
          <br>
          <br>
          <div class="alert-warn alert-white-bg">
            <div class="alert-warn-title">
              说明
            </div>
            <div>
              1、如果您的网站基于Asp.net，请依据您网站开发时使用的版本设置
            </div>
            <div>
              2、.NET4.0同时支持.net framework 4.0及.net framework 4.5
            </div>
          </div>
        </div>
        <div v-if="operateType === 'chain'" class="contentBox" style="height: 250px;">
          是否开启防盗链：
          <el-radio-group v-model="chain.radio">
            <el-radio :label="'open'">开启防盗链</el-radio>
            <el-radio :label="'close'">关闭防盗链</el-radio>
          </el-radio-group>
          <br>
          <br>
          <span v-show="chain.radio === 'open'">被盗链时发送的提示语：</span>
          <el-input v-show="chain.radio === 'open'" v-model="chain.fdl_txt" style="width: 300px"></el-input>
          <div class="alert-warn alert-white-bg">
            <div class="alert-warn-title">
              说明
            </div>
            <div>
              1、您网站上的音乐、视频、flash、压缩包文件、图片等，如果被其它网站或迅雷等软件盗用后，会对自己网站产生大量的无效流量并加重服务器负担。
            </div>
            <div>
              2、为了防止您的流量被盗用，系统默认开启了防盗链。
            </div>
            <div>
              3、默认设置受保护的文件后缀如下：.jpg， .gif， .png， .bmp， .mp3， .mp4， .wav， .wma， .rmvb， .avi， .wmv， .asf， .tar， .rm， .rpm， .mpg， .mpeg， .rar， .zip， .exe， .msi， .pdf。
            </div>
          </div>
        </div>
        <div v-if="operateType === 'compress'" class="contentBox" style="height: 300px;">
          压缩包：
          <el-input v-model="compress.zipfile" style="width: 150px;margin-right: 30px"></el-input>
          解压到：
          <el-input v-model="compress.unzipto" style="width: 150px;margin-right: 30px"></el-input>
          <el-button type="primary" style="vertical-align: 1px;" @click="WebUnZip">开始解压</el-button>
          <br>
          <br>
          <span style="margin-left: 12px">目录：</span>
          <el-input v-model="compress.catalog" style="width: 150px;margin-right: 30px"></el-input>
          压缩到：
          <el-input v-model="compress.zipto" style="width: 150px;margin-right: 30px"></el-input>
          <el-button type="primary" style="vertical-align: 1px;" @click="WebZip">开始压缩</el-button>
          <br>
          <br>
          <div class="alert-warn alert-white-bg">
            <div class="alert-warn-title">
              说明
            </div>
            <div>
              1、填写的文件和文件夹必须要以 web\ 或 data\ 开头，和您的FTP目录相对应。
            </div>
            <div>
              压缩举例： 把文件夹：web\test1\ 压缩到文件：data\test1.rar
            </div>
            <div>
              解压举例： 把压缩文件：data\test1.rar 解压到文件夹：web\test1\
            </div>
            <div>
              2、压缩文件最大限制为500M。
            </div>
          </div>
        </div>
        <div v-if="operateType === 'permission'" class="contentBox" style="height: 200px;">
          请输入文件夹路径：\web\
          <el-input v-model="permission.dirPathInput" style="width: 200px"></el-input>
          <br>
          <br>
          <el-button type="warning" style="vertical-align: 1px;" @click="ExecSet('close')">关闭此目录的执行权限</el-button>
          <el-button type="primary" style="vertical-align: 1px;" @click="ExecSet('open')">恢复此目录的执行权限</el-button>
          <br>
          <br>
          <div class="alert-warn alert-white-bg">
            <div class="alert-warn-title">
              说明
            </div>
            <div>
              1、通过该功能，您可以对指定的文件夹取消ASP/PHP/CGI/ASP.Net权限。 （对网站安全具有重要意义，例如防止黑客上传ASP木马到图片或头像目录去运行）
            </div>
          </div>
        </div>
        <div v-if="operateType === 'lock'" class="contentBox" style="height: 305px;">
          全局写入权限设置：
          <el-button type="warning" style="vertical-align: 1px;" @click="WriteSet(true,'close')">关闭</el-button>
          <el-button type="primary" style="vertical-align: 1px;" @click="WriteSet(true,'open')">打开</el-button>
          <br>
          <br>
          单独设置以下文件夹：\web\
          <el-input v-model="lock.dirPathInput" style="width: 150px"></el-input>
          <el-button type="warning" style="vertical-align: 1px;margin-left: 10px;" @click="WriteSet(false,'close')">关闭</el-button>
          <el-button type="primary" style="vertical-align: 1px;" @click="WriteSet(false,'open')">打开</el-button>
          <br>
          <br>
          <div class="alert-warn alert-white-bg">
            <div class="alert-warn-title">
              说明
            </div>
            <div>
              关闭写入权限，锁定虚拟主机，对安全有重要意义。建议按照以下步骤设置网站：
            </div>
            <div>
              1、关闭全局写入权限
            </div>
            <div>
              2、对于特定需要写入内容的文件夹，打开写入权限。
            </div>
            <div>
              2、对已经打开写入权限的文件夹，使用控制面板的“执行权限”功能，关闭执行权限。
            </div>
            <div>
              按照如上设置，您的网站安全性会大大提高
            </div>
            <div class="z-color-red">
              1、如果您的网站文件数量很多，更改写入权限可能需要比较长的时间，请耐心等待。
            </div>
            <div class="z-color-red">
              2、关闭写入权限后，您的FTP也将同时关闭写入权限。
            </div>
          </div>
        </div>
        <div v-if="operateType === 'blacklist'" class="contentBox" style="height: 300px;">
          <el-form label-width="150px" label-position="right">
            <el-form-item label="IP黑名单：">
              <el-input v-model="blacklist.addIndexInput" style="width: 300px"></el-input>
              <el-button type="primary" style="vertical-align: 1px;" @click="BlacklistAdd">添加</el-button>
            </el-form-item>
            <el-form-item label="">
              <ul class="index-list">
                <li v-for="(item, index) in blacklist.indexList" class="index-item clearfix">
                  <span class="index-item-rank">{{index + 1}}.</span>
                  <span class="index-item-name">{{item}}</span>
                  <div class="pull-right operate-box">
                    <a href="javascript:;" class="index-up" @click="BlacklistUp(index)" title="向上一位"></a>
                    <a href="javascript:;" class="index-down" @click="BlacklistDown(index)" title="向下一位"></a>
                    <a href="javascript:;" class="index-del" @click="BlacklistDel(index)" title="移除"></a>
                  </div>
                </li>
              </ul>
            </el-form-item>
          </el-form>
          <div class="alert-warn alert-white-bg">
            <div class="alert-warn-title">
              说明
            </div>
            <div>
              1、如果需要设置某个IP段，可以采用如下格式：123.123.123.*或123.123.*.*
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button v-if="operateType === 'mainpage'" type="primary" @click="IndexpageSet">确 定</el-button>
          <el-button v-if="operateType === 'set404'" type="primary" @click="Set404">确 定</el-button>
          <el-button v-if="operateType === 'errorscript'" type="primary" @click="ErrorScript">确 定</el-button>
          <el-button v-if="operateType === 'redirectJump'" type="primary" @click="RedirectJump">确 定</el-button>
          <el-button v-if="operateType === 'php'" type="primary" @click="Php">确认切换</el-button>
          <el-button v-if="operateType === 'net'" type="primary" @click="Net">确认切换</el-button>
          <el-button v-if="operateType === 'chain'" type="primary" @click="Chain">确 定</el-button>
          <el-button v-if="operateType === 'blacklist'" type="primary" @click="BlackList">确 定</el-button>
          <el-button @click="dialogOperate = false">取 消</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="操作保护"
        :visible.sync="dialogClearWeb"
        top="20%"
        width="660px"
        :lock-scroll=false
        :close-on-click-modal=false
        :close-on-press-escape=false
        custom-class="dialog">
        <div class="alert-warn">
          您正在执行关键操作，为了您的账户资产安全，请您进行二次验证：
        </div>
        <span class="z-font-size-12">为保证您的网站安全，请输入验证码：</span>
        <el-input v-model="clearWeb.captcha" style="width: 200px"></el-input>
        <img :src="captcha" title="点击更换" class="error-img" @click="changeYzm">
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="ClearWeb">确 定</el-button>
          <el-button @click="dialogClearWeb = false">取 消</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="操作保护"
        :visible.sync="dialogClearMysql"
        top="20%"
        width="660px"
        :lock-scroll=false
        :close-on-click-modal=false
        :close-on-press-escape=false
        custom-class="dialog">
        <div class="alert-warn">
          您正在执行关键操作，为了您的账户资产安全，请您进行二次验证：
        </div>
        <span class="z-font-size-12">为保证您的网站安全，请输入验证码：</span>
        <el-input v-model="mysql.captcha" style="width: 200px"></el-input>
        <img :src="captcha" title="点击更换" class="error-img" @click="changeYzm">
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="ClearMysql">确 定</el-button>
          <el-button @click="dialogClearMysql = false">取 消</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="操作保护"
        :visible.sync="dialogClearMssql"
        top="20%"
        width="660px"
        :lock-scroll=false
        :close-on-click-modal=false
        :close-on-press-escape=false
        custom-class="dialog">
        <div class="alert-warn">
          您正在执行关键操作，为了您的账户资产安全，请您进行二次验证：
        </div>
        <span class="z-font-size-12">为保证您的网站安全，请输入验证码：</span>
        <el-input v-model="mssql.captcha" style="width: 200px"></el-input>
        <img :src="captcha" title="点击更换" class="error-img" @click="changeYzm">
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="ClearMssql">确 定</el-button>
          <el-button @click="dialogClearMssql = false">取 消</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="流量详情"
        :visible.sync="dialogLiuliang"
        top="10%"
        width="760px"
        :lock-scroll=false
        :close-on-click-modal=false
        :close-on-press-escape=false
        custom-class="dialog">
        <el-button v-show="minubtn != 'lastmonth'" type="info" plain size="mini" @click="LogLiuliang('lastmonth')" style="margin-left: 10px">本月报表</el-button>
        <el-button v-show="minubtn === 'lastmonth'" type="info" size="mini">本月报表</el-button>
        <el-button v-show="minubtn != 'month'" type="info" plain size="mini" @click="LogLiuliang('month')" style="margin-left: 10px">上月报表</el-button>
        <el-button v-show="minubtn === 'month'" type="info" size="mini">上月报表</el-button>
        <el-button v-show="minubtn != 'lastday'" type="info" plain size="mini" @click="LogLiuliang('lastday')" style="margin-left: 10px">昨日报表</el-button>
        <el-button v-show="minubtn === 'lastday'" type="info" size="mini">昨日报表</el-button>
        <div id="main" style="width: 700px;height:400px;"></div>
      </el-dialog>
      <el-dialog
        :visible.sync="dialogExtlinks"
        top="12%"
        width="660px"
        :lock-scroll=false
        :close-on-click-modal=false
        :close-on-press-escape=false
        custom-class="dialog dialog-scroll">
        <span slot="title" class="el-dialog__title">外部连接管理</span>
        <div class="contentBox" style="height: 300px;">
          <div class="z-display-inlineBlock">
            <el-input v-model="sqlport.name" placeholder="请输入外部连接ip" style="width: 200px;margin-left: 10px"></el-input>
          </div>
          <el-button type="primary" style="vertical-align: 1px;" @click="SqlportAdd">增加</el-button>
          <el-table :data="sqlport.table" :show-header=false class="table-empty" style="width: 100%;margin-top: 20px;margin-bottom: 20px;">
            <el-table-column prop="ip" label="" width="497">
              <template slot-scope="scope">
                <a class="z-color-a a-underline-link" :href="scope.row.ip" target="_blank">{{scope.row.ip}}</a>
              </template>
            </el-table-column>
            <el-table-column prop="caozuo" label="" width="180">
              <template slot-scope="scope">
                <el-button type="danger" @click="SqlportDel(scope.row.ip)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="alert-warn alert-white-bg">
            <div class="alert-warn-title">
              说明
            </div>
            <div>
              1、基于您的数据库安全考虑，系统默认禁止外部IP连接数据库。
            </div>
            <div>
              2、如果您需要从外部IP连接数据库，可以在这里添加对应的外部IP。
            </div>
            <div>
              3、每个数据库最多可以添加5条外部IP。
            </div>
          </div>

        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogExtlinks = false">取 消</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title=""
        :visible.sync="dialogShowImg"
        top="2%"
        :lock-scroll=false
        width="26%"
        custom-class="show-img">
        <img width="100%" :src="showimgurl" alt="">
      </el-dialog>

      <!--blackpink-->
      <div v-if="dialogShadow" class="dialogShadow"></div>
      <dl v-if="dialogShadow" class="dialogBody ub-box ub-col">
        <dd class="dialogTitle z-font-size-16">
          <span class="z-font-size-18 z-padding-left-10-precent">提示信息</span>
          <a class="aui_close" href="javascript:;" @click="clickBtn()">×</a>
        </dd>
        <dd class="dialogContent z-color-666 z-font-size-15 ">
          <img style="margin-left: 30px;margin-right: 30px;vertical-align: middle" src="../../assets/imgs/uc_warn.png" alt="">
          <span class="z-font-size-15" v-if="info ==='freehost_domain'">免费主机仅限绑定在阿贝云注册的域名</span>
          <span class="z-font-size-15" v-if="info ==='no_beian_go'">域名未备案，到免备案服务中提交</span>
          <span class="z-font-size-15" v-if="info ==='smrz_fail'">您的帐户还没有实名认证</span>
          <br>
          <a v-if="info ==='freehost_domain'" href="/domain" class="z-color-a z-font-size-15" style="display: inline-block;margin-left: 154px">点击这里注册域名</a>
          <router-link v-if="info ==='no_beian_go'" to="/freeBeian" class="z-color-a z-font-size-15" style="display: inline-block;margin-left: 138px">点击进入免备案服务</router-link>
          <router-link v-if="info ==='smrz_fail'" to="/auth" class="z-color-a z-font-size-15" style="display: inline-block;margin-left: 127px">点击这里实名认证</router-link>
        </dd>
        <div class="dialogFooter ub-f1 ub-box ub-ver z-padding-v-15-precent">
          <!--<dd class="confirmBtn z-relative z-color-fff z-curPonit" @click="clickBtn(true)" style="background:#2ebace;">确认</dd>
          <dd class="confirmBtn z-relative z-color-fff z-curPonit" @click="clickBtn(false)" style="">取消</dd>-->
        </div>
      </dl>
    </div>
    </div>
  </div>
</template>
<script>
  import { MessageBox } from 'element-ui';
  import vhostService from 'business/vhostService.js'
  import userService from 'business/userService.js'
  import renewService from 'business/renewService.js'
  import upgradeService from 'business/upgradeService.js'
  import XdialogLoading from 'components/commons/XdialogLoading.vue'
  import XdialogWarning from 'components/commons/XdialogWarning.vue'
  import Vue from 'vue'
  import echarts from 'echarts/lib/echarts'
  import {mapGetters,mapActions} from 'vuex'
  export default {
    data () {
      return {
        dialogAddSubsite:false,
        dialogLoading:false,
        dialogWarning:false,
        dialogOperate:false,
        delayLoading:false,
        dialogWeb301:false,
        listLoading:false,
        logFileLoading:false,
        logStateLoading:false,
        logListLoading:false,
        dialogClearWeb:false,
        dialogLiuliang:false,
        dialogXufei:false,
        dialogXLevel:false,
        dialogClearMysql:false,
        dialogClearMssql:false,
        dialogExtlinks:false,
        dialogShadow:false,
        dialogShowImg:false,
        subsite:true,
        dialogSuccessMsg:'',
        warningMsg:'',
        operateType:'',
        operateName:'',
        activeName:'first',
        post_addr:[],
        vhost:{},
        PstateData:[],
        pstate:'',
        minubtn:'lastmonth',
        xufeiForm:{
          id:'',
          name:'',
          ftp:'',
          endtime:'',
          region: '1',
          coupon:'',
          yhq:[],
          newtime:'',
          price:'',
          loading:false,
          money:''
        },
        shengjiForm:{
          websize:'',
          daikuan:'',
          subweb:'',
          mysql:'',
          mssql:'',
          id:'',
          type:'',
          config:[],
          pset:[],
          coupon:'',
          yhq:[],
          endtime:'',
          price:'',
          loading:false,
          money:''
        },
        vhostInfo:{
          liuliang:'不限',
          mssql:'',
          domainname0:''
        },
        domain:{
          domainType:'http',
          domainTypeSelect:[{
            value: 'http',
            label: 'http://'
          }],
          name:'',
          table:[]
        },
        mainpage:{
          addIndexInput:'',
          indexList:[]
        },
        set404:{
          radio:0
        },
        errorscript:{
          radio:0
        },
        redirectJump:{
          radio:'close',
          RedirectURL:''
        },
        php:{
          radio:'5.2.9',
        },
        net:{
          radio:'2.0',
        },
        chain:{
          radio:'open',
          fdl_txt:'阿贝云提醒您：本站禁止盗链！'
        },
        compress:{
          zipfile:'data\\',
          unzipto:'web\\',
          catalog:'web\\',
          zipto:'data\\',
        },
        permission:{
          dirPathInput:''
        },
        lock:{
          dirPathInput:''
        },
        clearWeb:{
          captcha:''
        },
        blacklist:{
          addIndexInput:'',
          indexList:[]
        },
        subwebdir:'',
        selfdomain:'',
        subsiteList:[],
        SubWebDir:'',
        SubWeb:false,
        SubWebId:'',
        mysql:{
          captcha:''
        },
        mssql:{
          captcha:''
        },
        sqlport:{
          name:'',
          table:[]
        },
        sqltype:'mysql',
        mysqlTable: [{
          index:'1',
          date: '备份一：',
          name: '备份文件：',
          beifen:false
        }, {
          index:'2',
          date: '备份二：',
          name: '备份文件：',
          beifen:false
        }, {
          index:'3',
          date: '备份三：',
          name: '备份文件：',
          beifen:false
        }],
        mssqlTable: [{
          index:'1',
          date: '备份一：',
          name: '备份文件：',
          beifen:false
        }, {
          index:'2',
          date: '备份二：',
          name: '备份文件：',
          beifen:false
        }, {
          index:'3',
          date: '备份三：',
          name: '备份文件：',
          beifen:false
        }],
        websoftList:[],
        softname:'',
        softpath:'',
        logdate:'',
        lognum:'',
        logFile:[],
        logState:[],
        logUrlType:'',
        logList:[],
        logListType:'',
        logStatus:'',
        cardForm:{
          url:''
        },
        dataUrl:'',
        showimg:false,
        captcha:'https://api.abeiyun.com/www/yzm.php?rnd='+Math.random(),
        info:'',
        weixin:Boolean,
        delayState:'',
        nexttime:'',
        nickname:'',
        headimgurl:'',
        cardList: [],
        count:20,
        total:0,
        page:1,
        showimgurl:''
      }
    },
    components:{
      XdialogLoading,
      XdialogWarning
    },
    props:{
      hide:Boolean
    },
    mounted() {
      this.activeName = this.delay
      this.config()
    },
    computed: {
      region() {
        return this.xufeiForm.region
      },
      coupon() {
        return this.xufeiForm.coupon
      },
      coupon2() {
        return this.shengjiForm.coupon
      },
      ...mapGetters({
        delay:'getDelay'
      })
    },
    watch:{
      activeName(val){
        if(val === 'second'){
          this.SqlbakList()
        }
        if(val === 'third'){
          this.WebsoftList()
        }
        if(val === 'fourth'){
          this.$refs.el.style.visibility = 'hidden'
          this.logList = []
          this.logListType = ''
          this.LogFile()
          this.LogState()
        }
        if(val === 'five'){
          /*this.checkWeiXin()*/
          this.checkDelay()
          this.getPostAddr()
        }
        if(val === 'six'){
          this.SearchCard()
        }
      },
      region(){
        this.getPrice()
      },
      coupon(){
        this.getPrice()
      },
      coupon2(){
        this.levelPrice()
      }
    },
    methods:{
      async config() {
        this.vhost = sessionStorage.getItem('vhost') ? JSON.parse(sessionStorage.getItem('vhost')) : {'id': this.$route.params.id}
        await this.VhostQuery()
        this.Pstate(Number(this.vhostInfo.Pstate))
      },
      backToVhost(){
        this.$router.push('/product')
      },
      async Pstate(pstate) {
        let data = 'cmd=pstate'
        let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
        if(state.code === '000' ) {
          this.PstateData = vueData
          this.pstate = pstate ? [...vueData.filter(item => pstate === item[0])][0][1] : ''
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async VhostQuery() {
        this.listLoading = true
        let data = 'cmd=vhost_query'+
          '&id='+ this.vhost.id
        let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
        if(vueData.response == 200 ) {
          this.vhostInfo = vueData.msg
          this.vhostInfo.domainname0 = [...vueData.msg.domainname.filter(item => '0' === item.id)][0].DomainName
          this.listLoading = false
        }else {
          this.listLoading = false
          this.dialogWarning = true
          this.warningMsg = vueData.msg
        }
      },
      async FtpPwdSet() {
        const h = this.$createElement;
        MessageBox.prompt('请输入新密码：', '设置FTP账号密码', {
          message: h('p', null, [
            h('span', { style: 'font-size: 13px' }, '请输入新密码：'),
            h('span', { style: 'color: red; font-size: 13px' }, '密码8~32位,必须包含大写字母和小写字母和数字')
          ]),
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          lockScroll: false,
          inputPattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,32}$/,
          inputErrorMessage: '密码格式不正确'
        }).then(async({ value }) => {
          this.dialogLoading = true
          let data = 'cmd=ftp_pwd_set'+
            '&id='+ this.vhost.id +
            '&password=' + value
          let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
          if(vueData.response == 200 ) {
            this.dialogLoading = false
            this.$dialog({type:'success', info: vueData.msg, click () {}})
          }else {
            this.dialogLoading = false
            this.$dialog({type:'error', info: vueData.msg, click () {}})
          }
        }).catch(() => {

        });
      },
      async SqlbakList() {
        let data = 'cmd=sqlbak_list'+
          '&id='+ this.vhost.id
        let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
        if(vueData.response == 200 ) {
          let mysql = vueData.mysql
          let mssql = vueData.mssql
          this.mysqlTable[0].name = [...mysql.filter(item => item[0][0].slice(0,1) === '1')].length>0 ? '备份文件：'+[...mysql.filter(item => item[0][0].slice(0,1) === '1')][0][0]+'（'+ [...mysql.filter(item => item[0][0].slice(0,1) === '1')][0][1] +'）' : '备份文件：'
          this.mysqlTable[1].name = [...mysql.filter(item => item[0][0].slice(0,1) === '2')].length>0 ? '备份文件：'+[...mysql.filter(item => item[0][0].slice(0,1) === '2')][0][0]+'（'+ [...mysql.filter(item => item[0][0].slice(0,1) === '2')][0][1] +'）' : '备份文件：'
          this.mysqlTable[2].name = [...mysql.filter(item => item[0][0].slice(0,1) === '3')].length>0 ? '备份文件：'+[...mysql.filter(item => item[0][0].slice(0,1) === '3')][0][0]+'（'+ [...mysql.filter(item => item[0][0].slice(0,1) === '3')][0][1] +'）' : '备份文件：'
          this.mysqlTable[0].beifen = [...mysql.filter(item => item[0][0].slice(0,1) === '1')].length>0 ? true : false
          this.mysqlTable[1].beifen = [...mysql.filter(item => item[0][0].slice(0,1) === '2')].length>0 ? true : false
          this.mysqlTable[2].beifen = [...mysql.filter(item => item[0][0].slice(0,1) === '3')].length>0 ? true : false

          this.mssqlTable[0].name = [...mssql.filter(item => item[0][0].slice(0,1) === '1')].length>0 ? '备份文件：'+[...mssql.filter(item => item[0][0].slice(0,1) === '1')][0][0]+'（'+ [...mssql.filter(item => item[0][0].slice(0,1) === '1')][0][1] +'）' : '备份文件：'
          this.mssqlTable[1].name = [...mssql.filter(item => item[0][0].slice(0,1) === '2')].length>0 ? '备份文件：'+[...mssql.filter(item => item[0][0].slice(0,1) === '2')][0][0]+'（'+ [...mssql.filter(item => item[0][0].slice(0,1) === '2')][0][1] +'）' : '备份文件：'
          this.mssqlTable[2].name = [...mssql.filter(item => item[0][0].slice(0,1) === '3')].length>0 ? '备份文件：'+[...mssql.filter(item => item[0][0].slice(0,1) === '3')][0][0]+'（'+ [...mssql.filter(item => item[0][0].slice(0,1) === '3')][0][1] +'）' : '备份文件：'
          this.mssqlTable[0].beifen = [...mssql.filter(item => item[0][0].slice(0,1) === '1')].length>0 ? true : false
          this.mssqlTable[1].beifen = [...mssql.filter(item => item[0][0].slice(0,1) === '2')].length>0 ? true : false
          this.mssqlTable[2].beifen = [...mssql.filter(item => item[0][0].slice(0,1) === '3')].length>0 ? true : false
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async InitMysql() {
        this.dialogLoading = true
        let data = 'cmd=sql_init'+
          '&id='+ this.vhost.id +
          '&sql_type=mysql'
        let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {self.VhostQuery()}})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async InitMssql() {
        this.dialogLoading = true
        let data = 'cmd=sql_init'+
          '&id='+ this.vhost.id +
          '&sql_type=mssql'
        let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {self.VhostQuery()}})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async SqlSetpwd(sql) {
        const h = this.$createElement;
        MessageBox.prompt('请输入新密码：', sql === 'mysql' ? '设置mysql数据库密码' : '设置mssql数据库密码', {
          message: h('p', null, [
            h('span', { style: 'font-size: 13px' }, '请输入新密码：'),
            h('span', { style: 'color: red; font-size: 13px' }, '密码8~32位,必须包含大写字母和小写字母和数字')
          ]),
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          lockScroll: false,
          inputPattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,32}$/,
          inputErrorMessage: '密码格式不正确'
        }).then(async({ value }) => {
          this.dialogLoading = true
          let data = 'cmd=sql_setpwd'+
            '&id='+ this.vhost.id +
            '&sql_type='+ sql +
            '&password=' + value
          let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
          if(vueData.response == 200 ) {
            this.dialogLoading = false
            this.$dialog({type:'success', info: vueData.msg, click () {}})
          }else {
            this.dialogLoading = false
            this.$dialog({type:'error', info: vueData.msg, click () {}})
          }
        }).catch(() => {

        });
      },
      SqlClear(sql) {
        MessageBox.confirm('此操作会清空您当前数据库，是否确认操作', '清空数据库确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          lockScroll: false,
        }).then(async() => {
          if(sql === 'mysql'){
            this.mysql.captcha = ''
            this.dialogClearMysql = true
          }
          if(sql === 'mssql'){
            this.mssql.captcha = ''
            this.dialogClearMssql = true
          }
        }).catch(() => {

        });
      },
      async Extlinks(sql) {
        this.sqlport.table = []
        this.sqltype = sql
        this.dialogExtlinks = true
        let data;
        if(sql === 'mysql'){
          data = 'cmd=sql_port_open'+
            '&port=3306'+
            '&cmd_type=query'+
            '&id='+ this.vhost.id
        }
        if(sql === 'mssql'){
          data = 'cmd=sql_port_open'+
            '&port=1433'+
            '&cmd_type=query'+
            '&id='+ this.vhost.id
        }
        let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
        if(state.code === '000') {
          this.sqlport.name = ''
          this.sqlport.table = vueData.msg.map((item, index) => {
            return {
              id:item.id,
              ip:item.ip
            }
          })
        }else {
          this.$toast('服务器繁忙，请稍后重试','fail')
        }
      },
      async SqlportAdd() {
        let data;
        if(this.sqltype === 'mysql'){
          data = 'cmd=sql_port_open'+
            '&port=3306'+
            '&cmd_type=add'+
            '&id='+ this.vhost.id +
            '&ip='+ this.sqlport.name
        }
        if(this.sqltype === 'mssql'){
          data = 'cmd=sql_port_open'+
            '&port=1433'+
            '&cmd_type=add'+
            '&id='+ this.vhost.id +
            '&ip='+ this.sqlport.name
        }
        this.dialogLoading = true
        let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {self.Extlinks(self.sqltype)}})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async SqlportDel(ip) {
        MessageBox.confirm('确定删除此id?', '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          lockScroll: false,
          type: 'warning'
        }).then(async() => {
          this.dialogLoading = true
          let data;
          if(this.sqltype === 'mysql'){
            data = 'cmd=sql_port_open'+
              '&port=3306'+
              '&cmd_type=del'+
              '&id='+ this.vhost.id +
              '&ip='+ ip
          }
          if(this.sqltype === 'mssql'){
            data = 'cmd=sql_port_open'+
              '&port=1433'+
              '&cmd_type=del'+
              '&id='+ this.vhost.id +
              '&ip='+ ip
          }
          let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
          if(vueData.response == 200 ) {
            this.dialogLoading = false
            let self = this
            this.$dialog({type:'success', info: vueData.msg, click () {self.Extlinks(self.sqltype)}})
          }else {
            this.dialogLoading = false
            this.$dialog({type:'error', info: vueData.msg, click () {}})
          }
        }).catch(() => {

        });
      },
      async ClearMysql() {
        this.dialogLoading = true
        let data = 'cmd=sql_clear'+
          '&id='+ this.vhost.id +
          '&sql_type=mysql'+
          '&img_yzm='+ this.mysql.captcha
        let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {self.dialogClearMysql = false}})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async ClearMssql() {
        this.dialogLoading = true
        let data = 'cmd=sql_clear'+
          '&id='+ this.vhost.id +
          '&sql_type=mssql' +
          '&img_yzm='+ this.mssql.captcha
        let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {self.dialogClearMysql = false}})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async SqlBak(sql,idx) {
        let data = 'cmd=sql_bak'+
          '&id='+ this.vhost.id +
          '&sql_type='+ sql +
          '&filename='+ idx
        let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
        if(vueData.response == 200 ) {
          MessageBox.alert(vueData.msg, '提示信息', {
            confirmButtonText: '确定',
            lockScroll: false,
            callback: () => {
              this.SqlbakList()
            }
          });
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async SqlReback(sql,idx) {
        let data = 'cmd=sql_reback'+
          '&id='+ this.vhost.id +
          '&sql_type='+ sql +
          '&filename='+ idx
        let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
        if(vueData.response == 200 ) {
          MessageBox.alert(vueData.msg, '提示信息', {
            confirmButtonText: '确定',
            lockScroll: false,
            callback: () => {
              this.SqlbakList()
            }
          });
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async AddSubsite() {
        this.subwebdir = ''
        this.selfdomain = ''
        this.dialogAddSubsite = true
      },
      async SubwebList() {
        let data = 'cmd=subweb_list'+
          '&id='+ this.vhost.id
        let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
        if(vueData.response == 200 ) {
          this.subsiteList = vueData.msg.map((item, index) => {
            return {
              subid:item.id,
              SubWebDir:item.SubWebDir,
              domainname:item.domainname
            }
          })
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      SubManage(SubWebDir,subid) {
        this.SubWebDir = SubWebDir
        this.subsite = false
        this.SubWebId = subid
      },
      async SubwebAdd() {
        this.dialogAddSubsite = false
        this.dialogLoading = true
        let data = 'cmd=subweb_add'+
          '&id='+ this.vhost.id +
          '&subwebdir='+ this.subwebdir +
          '&selfdomain='+ this.selfdomain
        let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {self.SubwebList()}})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async SubwebDel(subid) {
        MessageBox.confirm('确定要删除这个子目录吗？删除后可以重新在此绑定?', '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          lockScroll: false,
          type: 'warning'
        }).then(async() => {
          this.dialogLoading = true
          let data = 'cmd=subweb_del'+
            '&id='+ this.vhost.id +
            '&sub_id='+ subid
          let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
          if(vueData.response == 200 ) {
            this.dialogLoading = false
            let self = this
            this.$dialog({type:'success', info: vueData.msg, click () {self.SubwebList()}})
          }else {
            this.dialogLoading = false
            this.$dialog({type:'error', info: vueData.msg, click () {}})
          }
        }).catch(() => {

        });

      },
      Operate(name,title,sub){
        if(sub){
          this.SubWeb = true
        }else{
          this.SubWeb = false
        }
        this.dialogOperate = true
        this.operateType = name
        this.operateName = title
        if(name === 'domain'){
          this.DomainList(sub)
        }
        if(name === 'mainpage'){
          this.VhostBasic(sub)
        }
        if(name === 'set404'){
          this.VhostBasic(sub)
        }
        if(name === 'errorscript'){
          this.VhostBasic(sub)
        }
        if(name === 'redirectJump'){
          this.VhostBasic(sub)
        }
        if(name === 'php'){
          this.VhostBasic(sub)
        }
        if(name === 'net'){
          this.VhostBasic(sub)
        }
        if(name === 'chain'){
          this.VhostBasic(sub)
        }
        if(name === 'compress'){
          this.VhostBasic()
        }
        if(name === 'permission'){
          this.VhostBasic(sub)
        }
        if(name === 'blacklist'){
          this.VhostBasic(sub)
        }
      },
      async VhostBasic(sub) {
        let data;
        if(sub){
          data = 'cmd=vhost_basic'+
            '&id='+ this.SubWebId
        }else{
          data = 'cmd=vhost_basic'+
            '&id='+ this.vhost.id
        }
        let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
        if(state.code === '000') {
          this.mainpage.indexList = vueData.IndexPage ? vueData.IndexPage.split(',') : []
          this.set404.radio = vueData.ErrPage ? Number(vueData.ErrPage.split('#')[1]) : 1
          this.errorscript.radio = Number(vueData.SendErr)
          this.redirectJump.radio = vueData.Pstate === '20' ? 'open' : 'close'
          this.redirectJump.RedirectURL = vueData.RedirectURL
          this.php.radio = vueData.PhpVer ? vueData.PhpVer : '5.2.9'
          this.net.radio = vueData.NetVer ? vueData.NetVer : '2.0'
          this.blacklist.indexList = vueData.RefuseIP ? vueData.RefuseIP.split('#')[1].split('@') : []
          if(vueData.fdl_set){
            this.chain.radio = vueData.fdl_set.split('#')[0] === '1' ? 'open' : 'close'
            this.chain.fdl_txt = vueData.fdl_set.split('#')[1]
          }else{
            this.chain.radio = 'open'
          }
        }else {
          this.$toast('服务器繁忙，请稍后重试','fail')
        }
      },
      async DomainList(sub) {
        let data;
        if(sub){
          data = 'cmd=domain_list'+
            '&id='+ this.SubWebId
        }else{
          data = 'cmd=domain_list'+
            '&id='+ this.vhost.id
        }
        let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
        if(state.code === '000') {
          this.domain.name = ''
          this.domain.table = vueData.map((item, index) => {
            return {
              id:item.id,
              domainname:'http://' + item.DomainName,
              beian:item.beian
            }
          })
        }else {
          this.$toast('服务器繁忙，请稍后重试','fail')
        }
      },
      async DomainAdd() {
        let data;
        if(this.SubWeb){
          data = 'cmd=domain_bind'+
            '&cmd_type=add'+
            '&sub_host_id='+ this.SubWebId +
            '&domainname='+ this.domain.name
        }else{
          data = 'cmd=domain_bind'+
            '&cmd_type=add'+
            '&id='+ this.vhost.id +
            '&domainname='+ this.domain.name
        }
        this.dialogLoading = true
        let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {self.DomainList(self.SubWeb)}})
        }else {
          this.dialogLoading = false
          if(vueData.msg === 'freehost_domain' || vueData.msg === 'no_beian_go' || vueData.msg === 'smrz_fail'){
            this.info = vueData.msg
            this.dialogShadow = true
          }else {
            this.$dialog({type:'error', info: vueData.msg, click () {}})
          }
        }
      },
      async DomainDel(id) {
        MessageBox.confirm('确定删除此绑定域名?', '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          lockScroll: false,
          type: 'warning'
        }).then(async() => {
          this.dialogLoading = true
          let data;
          if(this.SubWeb){
            data = 'cmd=domain_bind'+
              '&cmd_type=del'+
              '&sub_host_id='+ this.SubWebId +
              '&del_id='+ id
          }else{
            data = 'cmd=domain_bind'+
              '&cmd_type=del'+
              '&id='+ this.vhost.id +
              '&del_id='+ id
          }
          let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
          if(vueData.response == 200 ) {
            this.dialogLoading = false
            let self = this
            this.$dialog({type:'success', info: vueData.msg, click () {self.DomainList(this.SubWeb)}})
          }else {
            this.dialogLoading = false
            this.$dialog({type:'error', info: vueData.msg, click () {}})
          }
        }).catch(() => {

        });
      },
      Restart(sub) {
        if(sub){
          this.SubWeb = true
        }else{
          this.SubWeb = false
        }
        MessageBox.confirm('您确定重启主机么?', '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          lockScroll: false,
          type: 'warning'
        }).then(async() => {
          this.dialogLoading = true
          let data;
          if(this.SubWeb){
            data = 'cmd=host_reboot'+
              '&id='+ this.SubWebId
          }else{
            data = 'cmd=host_reboot'+
              '&id='+ this.vhost.id
          }
          let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
          if(vueData.response == 200 ) {
            this.dialogLoading = false
            let self = this
            this.$dialog({type:'success', info: vueData.msg, click () {self.dialogOperate = false}})
          }else {
            this.dialogLoading = false
            this.$dialog({type:'error', info: vueData.msg, click () {}})
          }
        }).catch(() => {

        });
      },
      IndexUp(index){
        if(index === 0){
          return false;
        }
        let temp = this.mainpage.indexList[index - 1];
        Vue.set(this.mainpage.indexList, index - 1, this.mainpage.indexList[index]);
        Vue.set(this.mainpage.indexList, index, temp);
      },
      IndexDown(index){
        if(index === this.mainpage.indexList.length - 1){
          return false;
        }
        let temp = this.mainpage.indexList[index + 1];
        Vue.set(this.mainpage.indexList, index + 1, this.mainpage.indexList[index]);
        Vue.set(this.mainpage.indexList, index, temp);
      },
      IndexDel(index) {
        this.mainpage.indexList.splice(index,1)
      },
      IndexAdd() {
        if(this.mainpage.addIndexInput != ''){
          this.mainpage.indexList.push(this.mainpage.addIndexInput)
        }
        this.mainpage.addIndexInput = ''
      },
      BlacklistUp(index){
        if(index === 0){
          return false;
        }
        let temp = this.blacklist.indexList[index - 1];
        Vue.set(this.blacklist.indexList, index - 1, this.blacklist.indexList[index]);
        Vue.set(this.blacklist.indexList, index, temp);
      },
      BlacklistDown(index){
        if(index === this.blacklist.indexList.length - 1){
          return false;
        }
        let temp = this.blacklist.indexList[index + 1];
        Vue.set(this.blacklist.indexList, index + 1, this.blacklist.indexList[index]);
        Vue.set(this.blacklist.indexList, index, temp);
      },
      BlacklistDel(index) {
        this.blacklist.indexList.splice(index,1)
      },
      BlacklistAdd() {
        if(this.blacklist.addIndexInput != ''){
          this.blacklist.indexList.push(this.blacklist.addIndexInput)
        }
        this.blacklist.addIndexInput = ''
      },
      async IndexpageSet() {
        this.dialogLoading = true
        let data;
        if(this.SubWeb){
          data = 'cmd=indexpage_set'+
            '&id='+ this.SubWebId +
            '&indexpage='+ this.mainpage.indexList.join(',')
        }else{
          data = 'cmd=indexpage_set'+
            '&id='+ this.vhost.id +
            '&indexpage='+ this.mainpage.indexList.join(',')
        }
        let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {self.dialogOperate = false}})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async Set404() {
        this.dialogLoading = true
        let data;
        if(this.SubWeb){
          data = 'cmd=page404_set'+
            '&id='+ this.SubWebId +
            '&page404='+ this.set404.radio
        }else{
          data = 'cmd=page404_set'+
            '&id='+ this.vhost.id +
            '&page404='+ this.set404.radio
        }
        let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {self.dialogOperate = false}})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async ErrorScript() {
        this.dialogLoading = true
        let data;
        if(this.SubWeb){
          data = 'cmd=senderr_set'+
            '&id='+ this.SubWebId +
            '&senderr='+ this.errorscript.radio
        }else{
          data = 'cmd=senderr_set'+
            '&id='+ this.vhost.id +
            '&senderr='+ this.errorscript.radio
        }
        let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {self.dialogOperate = false}})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async RedirectJump() {
        this.dialogLoading = true
        let data;
        if(this.SubWeb){
          if(this.redirectJump.radio === 'open'){
            let url = this.redirectJump.RedirectURL
            if(this.redirectJump.RedirectURL.indexOf('http://') == -1){
              url = 'http://' + this.redirectJump.RedirectURL
            }
            data = 'cmd=web301'+
              '&id='+ this.SubWebId +
              '&cmdtype='+ this.redirectJump.radio +
              '&url='+ url
          }
          if(this.redirectJump.radio === 'close'){
            data = 'cmd=web301'+
              '&id='+ this.SubWebId +
              '&cmdtype='+ this.redirectJump.radio
          }
        }else{
          if(this.redirectJump.radio === 'open'){
            let url = this.redirectJump.RedirectURL
            if(this.redirectJump.RedirectURL.indexOf('http://') == -1 && this.redirectJump.RedirectURL.indexOf('https://') == -1){
              url = 'http://' + this.redirectJump.RedirectURL
            }
            data = 'cmd=web301'+
              '&id='+ this.vhost.id +
              '&cmdtype='+ this.redirectJump.radio +
              '&url='+ url
          }
          if(this.redirectJump.radio === 'close'){
            data = 'cmd=web301'+
              '&id='+ this.vhost.id +
              '&cmdtype='+ this.redirectJump.radio
          }
        }
        let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, async click () {
              self.dialogOperate = false
              await self.VhostQuery()
              self.pstate = self.vhostInfo.Pstate ? [...self.PstateData.filter(item => Number(self.vhostInfo.Pstate) === item[0])][0][1] : ''
            }})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async Php() {
        this.dialogLoading = true
        let data;
        if(this.SubWeb){
          data = 'cmd=phpver'+
            '&id='+ this.SubWebId +
            '&phpver='+ this.php.radio
        }else{
          data = 'cmd=phpver'+
            '&id='+ this.vhost.id +
            '&phpver='+ this.php.radio
        }
        let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {self.dialogOperate = false}})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async Net() {
        this.dialogLoading = true
        let data;
        if(this.SubWeb){
          data = 'cmd=netver'+
            '&id='+ this.SubWebId +
            '&netver='+ this.net.radio
        }else{
          data = 'cmd=netver'+
            '&id='+ this.vhost.id +
            '&netver='+ this.net.radio
        }
        let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {self.dialogOperate = false}})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async Chain() {
        this.dialogLoading = true
        let data;
        if(this.SubWeb){
          if(this.chain.radio === 'open'){
            data = 'cmd=fdl_set'+
              '&id='+ this.SubWebId +
              '&cmdtype='+ this.chain.radio +
              '&fdl_txt='+ this.chain.fdl_txt
          }
          if(this.chain.radio === 'close'){
            data = 'cmd=fdl_set'+
              '&id='+ this.SubWebId +
              '&cmdtype='+ this.chain.radio
          }
        }else{
          if(this.chain.radio === 'open'){
            data = 'cmd=fdl_set'+
              '&id='+ this.vhost.id +
              '&cmdtype='+ this.chain.radio +
              '&fdl_txt='+ this.chain.fdl_txt
          }
          if(this.chain.radio === 'close'){
            data = 'cmd=fdl_set'+
              '&id='+ this.vhost.id +
              '&cmdtype='+ this.chain.radio
          }
        }
        let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {self.dialogOperate = false}})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async WebUnZip(){
        this.dialogLoading = true
        let data = 'cmd=web_zip'+
          '&id='+ this.vhost.id +
          '&cmdtype=0'+
          '&from_path='+ this.compress.zipfile +
          '&to_path='+ this.compress.unzipto
        let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {self.dialogOperate = false}})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async WebZip(){
        this.dialogLoading = true
        let data = 'cmd=web_zip'+
          '&id='+ this.vhost.id +
          '&cmdtype=1'+
          '&from_path='+ this.compress.catalog +
          '&to_path='+ this.compress.zipto
        let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {self.dialogOperate = false}})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      ConfiemClear(sub) {
        if(sub){
          this.SubWeb = true
        }else{
          this.SubWeb = false
        }
        MessageBox.confirm('您确认要清空主机内容么?', '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          lockScroll: false,
          type: 'warning'
        }).then(() => {
          this.dialogClearWeb = true
        }).catch(() => {

        });
      },
      async ClearWeb(){
        this.dialogLoading = true
        let data;
        if(this.SubWeb){
          data = 'cmd=web_clear'+
            '&id='+ this.SubWebId +
            '&img_yzm='+ this.clearWeb.captcha
        }else{
          data = 'cmd=web_clear'+
            '&id='+ this.vhost.id +
            '&img_yzm='+ this.clearWeb.captcha
        }
        let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {self.dialogClearWeb = false}})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async ExecSet(type){
        this.dialogLoading = true
        let data;
        if(this.SubWeb){
          data = 'cmd=exec_Set'+
            '&id='+ this.SubWebId +
            '&cmdtype='+ type +
            '&path='+ this.permission.dirPathInput
        }else{
          data = 'cmd=exec_Set'+
            '&id='+ this.vhost.id +
            '&cmdtype='+ type +
            '&path='+ this.permission.dirPathInput
        }
        let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {self.dialogOperate = false}})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async WriteSet(quanju,type){
        this.dialogLoading = true
        let data;
        if(quanju){
          data = 'cmd=write_Set'+
            '&id='+ this.vhost.id +
            '&cmdtype='+ type
        }else{
          data = 'cmd=write_Set'+
            '&id='+ this.vhost.id +
            '&cmdtype='+ type +
            '&path='+ this.lock.dirPathInput
        }
        let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {self.dialogOperate = false}})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async BlackList() {
        this.dialogLoading = true
        let data;
        if(this.SubWeb){
          data = 'cmd=iphmd_Set'+
            '&id='+ this.SubWebId +
            '&ip_list='+ this.blacklist.indexList.join(',')
        }else{
          data = 'cmd=iphmd_Set'+
            '&id='+ this.vhost.id +
            '&ip_list='+ this.blacklist.indexList.join(',')
        }
        let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {self.dialogOperate = false}})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async WebsoftList() {
        let data = 'cmd=web_soft_list'
        let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
        if(state.code === '000' ) {
          this.websoftList = vueData
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async WebInstall() {
        this.dialogLoading = true
        let data = 'cmd=web_install' +
          '&id='+ this.vhost.id +
          '&path='+ this.softpath +
          '&softname='+ this.softname
        let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
        if(vueData.response == 200) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {
              self.softname = ''
              self.softpath = ''
            }})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async LogFile() {
        this.logFileLoading = true
        let data = 'cmd=log_fenxi' +
          '&id='+ this.vhost.id +
          '&query_type=filetype'
        let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
        if(state.code === '000' ) {
          this.logdate = vueData.date
          this.lognum = vueData.allip
          this.logFileLoading = false
          this.logFile = vueData.data
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async LogState() {
        this.logStateLoading = true
        let data = 'cmd=log_fenxi' +
          '&id='+ this.vhost.id +
          '&query_type=state'
        let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
        if(state.code === '000' ) {
          this.logStateLoading = false
          this.logState = vueData
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async BytesList(content,type) {
        let by_type
        if(type === '状态码'){
          by_type = 'cs_status'
        }else{
          by_type = 'cs_referer'
        }
        this.logUrlType = type
        this.logListType = 'url'
        this.logStatus = content
        this.logListLoading = true
        let data = 'cmd=log_fenxi' +
          '&id='+ this.vhost.id +
          '&query_type=domain' +
          '&by_type=' + by_type +
          '&orderby=all_bytes' +
          '&content='+ content
        let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
        if(state.code === '000' ) {
          this.logListLoading = false
          this.$refs.el.style.visibility = 'visible'
          this.logList = vueData
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async HitsList(content,type) {
        let by_type
        if(type === '状态码'){
          by_type = 'cs_status'
        }else{
          by_type = 'cs_referer'
        }
        this.logUrlType = type
        this.logListType = 'url'
        this.logStatus = content
        this.logListLoading = true
        let data = 'cmd=log_fenxi' +
          '&id='+ this.vhost.id +
          '&query_type=domain' +
          '&by_type=' + by_type +
          '&orderby=all_hits' +
          '&content='+ content
        let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
        if(state.code === '000' ) {
          this.logListLoading = false
          this.$refs.el.style.visibility = 'visible'
          this.logList = vueData
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async SourceDomain() {
        this.logListType = 'domain'
        this.logListLoading = true
        let data = 'cmd=log_fenxi' +
          '&id='+ this.vhost.id +
          '&query_type=domain'
        let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
        if(state.code === '000' ) {
          this.logListLoading = false
          this.$refs.el.style.visibility = 'visible'
          this.logList = vueData
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async IPBandwidth() {
        this.logListType = 'ip'
        this.logListLoading = true
        let data = 'cmd=log_fenxi' +
          '&id='+ this.vhost.id +
          '&query_type=ip'
        let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
        if(state.code === '000' ) {
          this.logListLoading = false
          this.$refs.el.style.visibility = 'visible'
          this.logList = vueData
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async LogLiuliang(type) {
        this.minubtn = type
        this.dialogLiuliang = true
        let data = 'cmd=log_liuliang' +
          '&id='+ this.vhost.id +
          '&query_type=' + type
        let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
        if(state.code === '000' ) {
          let byteunit  = this.bytesToSize2(vueData.length > 0 ? this.getMax(vueData) : '')
          let myChart = echarts.init(document.getElementById('main'));
          let option = {
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
                animation: false,
                label: {
                  backgroundColor: '#ccc',
                  borderColor: '#aaa',
                  borderWidth: 1,
                  shadowBlur: 0,
                  shadowOffsetX: 0,
                  shadowOffsetY: 0,
                  textStyle: {
                    color: '#222'
                  }
                }
              },
              formatter: function (params) {
                return params[0].name + '<br />' + '流量：' + params[0].value + params[0].data.unit;
              }
            },
            xAxis: {
              type: 'category',
              data: vueData.map((item, index) => {
                if(type === 'lastmonth' || type === 'month'){
                  return item.setdate
                }
                if(type === 'lastday'){
                  return item.cur_hour + '时'
                }
              }),
            },
            yAxis: {
              type: 'value',
              axisLabel: {
                formatter: '{value}'+ byteunit
              }
            },
            series: [{
              data: vueData.map((item, index) => {
                return {
                  value:this.bytesToSize(item.all_bytes,byteunit),
                  unit:byteunit
                }
              }),
              type: 'line',
              smooth: true
            }]
          };
          myChart.setOption(option,true)
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      changeYzm() {
        this.captcha = 'https://api.abeiyun.com/www/yzm.php?rnd='+Math.random()
      },
      getMax(arr){
        let max = arr[0].all_bytes
        for(let x in arr){
          if(arr[x].all_bytes > max){
            max = arr[x].all_bytes
          }
        }
        return max
      },
      bytesToSize(bps,unit) {
        if (bps === 0) return '0';
        let k = 1024,i = 0;
        if(unit == 'B'){
          i = 0
        }
        if(unit == 'KB'){
          i = 1
        }
        if(unit == 'MB'){
          i = 2
        }
        if(unit == 'GB'){
          i = 3
        }
        if(unit == 'TB'){
          i = 3
        }
        return (bps / Math.pow(k, i)) > 1 ? (bps / Math.pow(k, i)).toPrecision(4) : (bps / Math.pow(k, i)).toFixed(4);
      },
      bytesToSize2(bps) {
        if (bps === '') return '';
        if (bps === 0) return 'B';
        var k = 1024, // or 1024
          sizes = ['B', 'KB', 'MB', 'GB', 'TB'],
          i = Math.floor(Math.log(bps) / Math.log(k));

        return sizes[i];
      },
      Rennew(id,endtime) {
        this.xufeiForm.id = id
        this.xufeiForm.endtime = endtime
        this.dialogXufei = true
        this.couponInfo()
        this.getPrice()
      },
      async Shengji(id,endtime,websize,daikuan,subweb,mysql,mssql) {
        this.shengjiForm.id = id
        this.shengjiForm.endtime = endtime
        this.shengjiForm.websize = websize
        this.shengjiForm.daikuan = daikuan.replace('(','').replace(')','')
        this.shengjiForm.subweb = subweb.replace('个','')
        this.shengjiForm.mysql = mysql
        this.shengjiForm.mssql = mssql
        await this.levelShow()
        await this.levelPrice()
      },
      async getPrice() {
        this.xufeiForm.loading = true
        let data = 'cmd=renew'+
          '&yewu_type=vhost'+
          '&yewu_id='+ this.xufeiForm.id +
          '&renew_time='+ this.xufeiForm.region +
          '&yhq_id='+ this.xufeiForm.coupon +
          '&ac_type=getprice'
        let {vueData, state} = await renewService.transformToVue('renewInfo','POST',data)
        if(vueData.response == 200 ) {
          this.xufeiForm.loading = false
          this.xufeiForm.name = vueData.pname
          this.xufeiForm.ftp = vueData.ftp_user
          this.xufeiForm.newtime = vueData.endtime
          this.xufeiForm.price = vueData.price
        }else {
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async Renew() {
        this.dialogLoading = true
        let data = 'cmd=renew'+
          '&yewu_type=vhost'+
          '&yewu_id='+ this.xufeiForm.id +
          '&renew_time='+ this.xufeiForm.region +
          '&yhq_id='+ this.xufeiForm.coupon +
          '&ac_type=renew'
        let {vueData, state} = await renewService.transformToVue('renewInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {
              self.dialogXufei = false
              self.VhostQuery()
            }})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async levelShow() {
        let data = 'cmd=vhost_show'+
          '&yewu_id='+ this.shengjiForm.id
        let {vueData, state} = await upgradeService.transformToVue('upgradeInfo','POST',data)
        if(vueData.response == 200 ) {
          this.shengjiForm.type = vueData.msg[0].id
          this.shengjiForm.config = vueData.msg.map((item, index) => {
            return {
              value: item.id,
              label: item.pname,
            }
          })
        }else {
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async levelPrice() {
        this.shengjiForm.loading = true
        let data = 'cmd=vhost_price'+
          '&yewu_id='+ this.shengjiForm.id +
          '&new_type_id='+ this.shengjiForm.type +
          '&yhq_id='+ this.shengjiForm.coupon
        let {vueData, state} = await upgradeService.transformToVue('upgradeInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogXLevel = true
          this.couponInfo()
          this.shengjiForm.loading = false
          this.shengjiForm.pset = vueData.pset
          this.shengjiForm.price = vueData.msg
        }else {
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async Level() {
        this.dialogLoading = true
        let data = 'cmd=vhost_upgrade'+
          '&yewu_id='+ this.shengjiForm.id +
          '&new_type_id='+ this.shengjiForm.type +
          '&yhq_id='+ this.shengjiForm.coupon
        let {vueData, state} = await upgradeService.transformToVue('upgradeInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {self.dialogXLevel = false}})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async couponInfo() {
        let {vueData, state} = await userService.transformToVue('userInfo','POST','cmd=userinfo')
        if(state.code === '000' ) {
          this.xufeiForm.money = vueData.msg.money
          this.shengjiForm.money = vueData.msg.money
          let onuse = vueData.msg.yhq.onuse.map((item, index) => {
            return {
              value: item.yhq_id,
              label: item.yhq_id+'(可优惠'+ item.money_all +'元，最低消费满'+ item.money_need +'元可使用)',
              yhq_use: item.yhq_use
            }
          })
          this.xufeiForm.yhq = onuse.filter(items => {
            return items.yhq_use === '续费'
          })
          this.xufeiForm.yhq.unshift({
            value: '',
            label: '不使用优惠券',
            yhq_use: ''
          })
          this.shengjiForm.yhq = onuse.filter(items => {
            return items.yhq_use === '续费'
          })
          this.shengjiForm.yhq.unshift({
            value: '',
            label: '不使用优惠券',
            yhq_use: ''
          })
        }else {
          this.$toast('请刷新页面','fail')
        }
      },
      changeConfig(view) {
        this.levelPrice()
      },
      /*async checkWeiXin() {
        this.delayLoading = true
        let {vueData, state} = await userService.transformToVue('userInfo','POST','cmd=check_wx_bind')
        if(state.code === '000' ) {
          if(vueData.response == 200) {
            this.delayLoading = false
            this.weixin = true
            this.nickname = vueData.msg.nickname
            this.headimgurl = vueData.msg.headimgurl
          }else {
            this.delayLoading = false
            this.weixin = false
          }
        }else {
          this.$toast('请刷新页面','fail')
        }
      },*/
      async checkDelay() {
        let {vueData, state} = await renewService.transformToVue('renewInfo','POST','cmd=check_free_delay&ptype=vhost')
        if(vueData.response == 200) {
          this.nexttime = vueData.msg.next_time
          if(vueData.msg.delay_enable == 0) {
            this.delayState = 0
          }else{
            this.delayState = vueData.msg.delay_state
          }
        }else {
          this.$toast('请刷新页面','fail')
        }
      },
      imgPreview (file) {
        let self = this;
        // 看支持不支持FileReader
        if (!file || !window.FileReader) return;

        if (/^image/.test(file.type)) {
          // 创建一个reader
          var reader = new FileReader();
          // 将图片将转成 base64 格式
          reader.readAsDataURL(file);
          // 读取成功后的回调
          reader.onloadend = function () {
            self.dataUrl = this.result;
          }
        }
        this.showimg = true
      },
      handleFileChange () {
        let inputDOM = this.$refs.inputer;
        // 通过DOM取文件数据
        this.file  = inputDOM.files[0];
        // 这里就可以获取到文件的名字了
        this.fileName = this.file.name;

        this.imgPreview(this.file);
      },
      async submitrForm() {
        this.dialogLoading = true
        let formData = new window.FormData();
        formData.append('cmd', 'free_delay_add')
        formData.append('ptype', 'vhost')
        formData.append('url', this.cardForm.url)
        formData.append('yanqi_img', this.$refs.inputer.files[0])
        let {vueData, state} = await renewService.transformToVue('renewInfo','POST',formData)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {
              self.showimg = false
              self.activeName = 'six'
            }})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async SearchCard() {

        let data = 'cmd=free_delay_list'+'&ptype=vhost'+'&count='+ this.count + '&page='+ this.page
        let {vueData, state} = await renewService.transformToVue('renewInfo','POST',data)
        if(vueData.response == 200 ) {
          this.total = vueData.msg.allcount
          this.cardList = vueData.msg.content.map((item, index) => {
            return {
              id:index + 1,
              Img:item.img_fatie,
              Url:item.url,
              SetTime:item.SetTime,
              CheckTime:item.CheckTime,
              State:item.State,
            }
          })
          this.listLoading = false
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async getPostAddr() {
        let data = 'cmd=get_free_post_addr'
        let {vueData, state} = await renewService.transformToVue('renewInfo','POST',data)
        if(vueData.response == 200 ) {
          this.post_addr = vueData.msg
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      handleCurrentChange(val) {
        this.page = val;
        this.SearchCard()
      },
      handleSizeChange(val) {
        this.count = val
        this.SearchCard()
      },
      clickBtn() {
        this.dialogShadow = false
      },
      LargeImg(url) {
        this.dialogShowImg = true
        this.showimgurl = url
      },
    }
  }
</script>
<style scoped>
  .page {
    margin-top: 45px;
    width: 100%;
    background-color: #fff;
  }
  .page-main { border: 0}
  .panel-heading { padding: 5px 0 0 0; }
  .hideleft { margin-left: 80px; }
  .server-header {
    height: 96px;
    margin-top: 18px;
    margin-bottom: 30px;
    background-repeat: no-repeat;
    background-position: left center;
  }
  /*.server-header.vhost {
    position: relative;
    background: url(../../assets/imgs/biz_state_host.png) no-repeat left center;
  }*/
  .server-header > p {
    margin: 10px 0;
    font-size: 12px;
    color: #a0a2a3;
  }
  .server-header > p > span {
    margin-right: 25px;
  }
  .server-header-table td {
    padding-bottom: 16px;
    font-size: 12px;
    color: #a0a2a3;
  }
  .row-title {
    background-color: #f7f9fa;
    font-size: 12px;
    color: #636566;
    font-weight: 700;
    padding-left: 16px;
    border-top: 1px solid #e5e5e5;
    border-bottom: 1px solid #e5e5e5;
    line-height: 40px;
  }
  .row-title-border {
    border-bottom:0;padding-left: 9px;border-left: 1px solid #e5e5e5;border-right: 1px solid #e5e5e5;
  }
  .row-border { border-bottom: 1px solid #eee; }
  .grid-content {
    line-height: 50px;
  }
  .grid-content-small {
    line-height: 35px;
  }
  .z-padding-left-25-precent {
    padding-left: 2.5rem;
  }
  .host-opicon-domain {
    background: url(../../assets/imgs/host_operate_domain.png) no-repeat center 20px;
  }
  .host-opicon-restart {
    background: url(../../assets/imgs/host_operate_restart.png) no-repeat center 20px;
  }
  .host-opicon-mainpage {
    background: url(../../assets/imgs/host_operate_mainpage.png) no-repeat center 20px;
  }
  .host-opicon-404 {
    background: url(../../assets/imgs/host_operate_404.png) no-repeat center 20px;
  }
  .host-opicon-errorscript {
    background: url(../../assets/imgs/host_operate_error.png) no-repeat center 20px;
  }
  .host-opicon-redirectJump {
    background: url(../../assets/imgs/host_operate_redirect.png) no-repeat center 20px;
  }
  .host-opicon-php {
    background: url(../../assets/imgs/host_operate_php.png) no-repeat center 20px;
  }
  .host-opicon-net {
    background: url(../../assets/imgs/host_operate_dotnet.png) no-repeat center 20px;
  }

  .host-opicon-chain {
    background: url(../../assets/imgs/host_operate_antileech.png) no-repeat center 20px;
  }
  .host-opicon-compress {
    background: url(../../assets/imgs/host_operate_compress.png) no-repeat center 20px;
  }
  .host-opicon-clearWeb {
    background: url(../../assets/imgs/host_operate_clear.png) no-repeat center 20px;
  }
  .host-opicon-permission {
    background: url(../../assets/imgs/host_operate_permission.png) no-repeat center 20px;
  }
  .host-opicon-lock {
    background: url(../../assets/imgs/host_operate_dir.png) no-repeat center 20px;
  }
  .host-opicon-chain {
    background: url(../../assets/imgs/host_operate_antileech.png) no-repeat center 20px;
  }
  .host-opicon-preInstall {
    background: url(../../assets/imgs/host_operate_preinstall.png) no-repeat center 20px;
  }
  .host-opicon-chain {
    background: url(../../assets/imgs/host_operate_antileech.png) no-repeat center 20px;
  }
  .sql-password {
    background: url(../../assets/imgs/sql_password.png) no-repeat center 20px;
  }
  .sql-clear {
    background: url(../../assets/imgs/sql_clear.png) no-repeat center 20px;
  }
  .sql-links {
    background: url(../../assets/imgs/sql_links.png) no-repeat center 20px;
  }
  .operate-item {
    float: left;
    display: none;
    width: 104px;
    height: 104px;
    border: 1px solid #ddd;
    margin-right: 25px;
    margin-top: 20px;
    padding-top: 72px;
    text-align: center;
    line-height: 1;
    color: #262829;
    cursor: pointer;
    box-sizing: border-box;
  }
  .operate-item:hover {
    border-color: #00aaff;
    color: #00aaff;
    text-decoration: none;
  }
  .alert-warn {
    margin-bottom: 20px;
  }
  .alert-warn.alert-white-bg {
    border: none;
    padding: 0px;
    background: #fff;
    line-height: 2em;
    color: #aaa;
  }
  .alert-warn.alert-white-bg .alert-warn-title {
    color: #ff8800;
  }
  .index-list {
    width: 340px;
    height: 153px;
    border: 1px solid #ccc;
    overflow-y: auto;
  }
  .index-item {
    border-top: 1px solid #eee;
    height: 30px;
    line-height: 30px;
    padding: 0 10px;
  }
  .index-item-rank {
    color: #a0a2a3;
  }
  .operate-box {
    display: none;
    height: 30px;
    line-height: 30px;
    box-sizing: border-box;
  }
  .index-item:first-child {
    border-top: none;
  }
  .index-item:first-child .operate-box {
    display: block;
  }
  .index-item:hover .operate-box {
    display: block;
  }
  .operate-box {
    padding-top: 4px;
  }
  .operate-box a {
    background: no-repeat center;
    display: inline-block;
    width: 19px;
    height: 19px;
  }
  a.index-up {
    background-image: url(../../assets/imgs/host_icon_up.png);
  }
  a.index-down {
    background-image: url(../../assets/imgs/host_icon_down.png);
  }
  a.index-del {
    background-image: url(../../assets/imgs/host_icon_delete.png);
  }

  .host-uselevel-bar.progress {
    display: inline-block;
    margin-bottom: -11px;
    height: 32px;
    border-radius: 0;
  }
  .host-uselevel-bar {
    position: relative;
    width: 300px;
  }
  .host-uselevel-bar .progress-bar-blue {
    background: #00aaff;
  }
  .usage-text {
    position: absolute;
    left: 50%;
    top: 10px;
    line-height: 1;
    margin-left: -20px;
  }
  .progress {
    height: 20px;
    margin-bottom: 20px;
    overflow: hidden;
    background-color: #f5f5f5;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 2px rgba(0,0,0,.1);
    box-shadow: inset 0 1px 2px rgba(0,0,0,.1);
  }
  .progress-bar {
    float: left;
    width: 0;
    height: 100%;
    font-size: 12px;
    line-height: 20px;
    color: #fff;
    text-align: center;
    background-color: #337ab7;
    -webkit-box-shadow: inset 0 -1px 0 rgba(0,0,0,.15);
    box-shadow: inset 0 -1px 0 rgba(0,0,0,.15);
    -webkit-transition: width .6s ease;
    -o-transition: width .6s ease;
    transition: width .6s ease;
  }
  .error-img {
    width: 100px;
    height: 30px;
    vertical-align: top;
    margin-left: 10px;
    cursor: pointer;
  }
  .table-yuzhuang {
    width:210px;border-collapse: collapse;float: left;margin: 5px 10px;border-top: 1px solid #ddd;
  }
  .table-yuzhuang td {
    vertical-align: middle;
    border: 1px solid #ddd;
    padding: 8px;
    line-height: 1.42857143;
  }
  .table-yuzhuang input[type="radio"] {
    margin: 10px;
  }
  .table-log {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 18px;
  }
  .table-log td{
    vertical-align: middle;
    border: 1px solid #ddd;
    padding: 8px;
    line-height: 23px;
  }
  .table-log th{
    vertical-align: middle;
    border: 1px solid #ddd;
    padding: 8px;
    line-height: 23px;
    background: #eee;
    font-weight: 700;
    text-align: left;
  }

  .alert-info {
    margin-bottom: 20px;
  }
  .alert-deng {
    margin-bottom: 50px;
  }
  .red-chunk {
    display: inline-block;
    background-color: #e35a55;
    color: #fff;
    padding: 2px 6px;
  }
  .col-img {
    border: solid 1px #bbbaba;
    width: 135px;
    height: 102px;
    border-radius: 3px;
    margin-right: 10px;
  }
  .choose-file {
    display: inline-block;
    position: absolute;
    padding: 4px 12px;
    margin-bottom: 0;
    font-size: 13px;
    line-height: 18px;
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    color: #fff;
    border-color: #2082dd;
    background-color: #2a89e0;
    border-radius: 2px;
  }
  .header-left {
    height: 96px;
    width: 96px;
    background-color: #00AAFF;
  }
  .header-left-icon {
    width: 59px;
    height: 58px;
    background: url(../../assets/imgs/freevhost.png) no-repeat;
  }
  .header-right {
    padding-left: 15px;
  }
  .delaybox {
    width: 374px;
    height: 180px;
    background: #fafafa;
    border: 1px solid #bababa;
    text-align: center;
    margin-left: 40px;
  }

  .dialogShadow{position:fixed;z-index:9900;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.5);}
  .dialogBody{position:fixed;z-index:9909;top:37%;left:50%;transform:translateX(-50%);min-width:32rem;background:#fff;box-shadow: 0 0 10px 3px rgba(0,0,0,.2);animation:dialogAnimStart .2s forwards}
  .dialogTitle{position:relative;padding:1rem 0;background:#f7f9fa;color:#636566;}
  .dialogContent{padding: 2rem 2rem 2rem 0}
  .dialogFooter{background:#f7f9fa;}
  @keyframes dialogAnimEnd{
    from{opacity:1}
    to{opacity:0}
  }
  .aui_close {
    position: absolute;
    padding: 0;
    top: 31%;
    right: 22px;
    width: 21px;
    height: 21px;
    line-height: 21px;
    font-size: 30px;
    color: #636566;
    text-align: center;
    font-family: Helvetica, STHeiti;
  }
</style>





// WEBPACK FOOTER //
// src/pages/product/freeVhost.vue